import * as Yup from "yup";
import React, {Fragment} from "react";
import {
  CaseForms,
  CaseMutationType,
  CaseStepperType,
  PersonRoleType,
  PersonSex,
  PersonType,
  UserRoleEnum,
  TipoBollettaRecapito
} from "../../../helpers/enums";
import {CaseFormField} from "../CaseGenerator";

import {Col, Row} from "react-bootstrap";
import {
  TranslatedText,
  getValidationRule,
  getCorrectLink,
  getStandardAddressFormat,
  removeRequiredStep,
  removeDeletedLayoutFields, getValidationObject,
  getCities
} from "../../../helpers/helpers";
import moment from "moment";
import DigitalizzazioneDocument from "../custom-steps/custom-digitalizzazione-step/DigitalizzazioneDocument";
import getMenuConfig from "../../../helpers/menuConfig";

let sign = false;
const {
  pdfLinks: { casesInfoVoltura }, 
} = getMenuConfig();
const InfoLabel = ({ label = "Test label" }) => {
  return (
    <div className="info-label">
      <span className="gc-icon-functional-attention-2-col">
        <span className="path1"></span>
        <span className="path2"></span>
      </span>
      <p>{label}</p>
    </div>
  );
};
const TutelaPerditeTable = () => {

  return (
    <div style={{marginTop: "10px", marginBottom: "10px"}}>
      <table className="table table-striped">
        <caption aria-label="tutelaPedite.captionTable.dichiarazioneSostitutiva"></caption>       
        <thead>
          <tr>
            <th scope="col" aria-label="tutelaPerdite.dichiarazioneSostitutiva.content.declaration.table.col_1"></th>
            <th scope="col" aria-label="tutelaPerdite.dichiarazioneSostitutiva.content.declaration.table.col_2"></th>
            <th scope="col" aria-label="tutelaPerdite.dichiarazioneSostitutiva.content.declaration.table.col_3"></th>
            <th scope="col" aria-label="tutelaPerdite.dichiarazioneSostitutiva.content.declaration.table.col_4"></th>
            <th scope="col" aria-label="tutelaPerdite.dichiarazioneSostitutiva.content.declaration.table.col_5"></th>
          </tr>
        </thead>
        <tbody>
        <tr>
          <th scope="row">
            <TranslatedText i18nKey="tutelaPerdite.dichiarazioneSostitutiva.content.declaration.table.row_1.title_1"/>
          </th>
          <td>
            <TranslatedText i18nKey="tutelaPerdite.dichiarazioneSostitutiva.content.declaration.table.row_1.content_1"/>
          </td>
          <td>
            <TranslatedText i18nKey="tutelaPerdite.dichiarazioneSostitutiva.content.declaration.table.row_1.content_2"/>
          </td>
          <td>
            <TranslatedText i18nKey="tutelaPerdite.dichiarazioneSostitutiva.content.declaration.table.row_1.content_3"/>
          </td>
          <td>
            <TranslatedText i18nKey="tutelaPerdite.dichiarazioneSostitutiva.content.declaration.table.row_1.content_4"/>
          </td>
        </tr>
        <tr>
          <th scope="row">
            <TranslatedText i18nKey="tutelaPerdite.dichiarazioneSostitutiva.content.declaration.table.row_2.title_1"/>
          </th>
          <td>
            <TranslatedText i18nKey="tutelaPerdite.dichiarazioneSostitutiva.content.declaration.table.row_2.content_1"/>
          </td>
          <td>
            <TranslatedText i18nKey="tutelaPerdite.dichiarazioneSostitutiva.content.declaration.table.row_2.content_2"/>
          </td>
          <td>
            <TranslatedText i18nKey="tutelaPerdite.dichiarazioneSostitutiva.content.declaration.table.row_2.content_3"/>
          </td>
          <td>
            <TranslatedText i18nKey="tutelaPerdite.dichiarazioneSostitutiva.content.declaration.table.row_2.content_4"/>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  );
};




const Step2_2 = (props) => {
  // Ricevono come props informazioni sui campi e sul layout
  const {fields, layout} = props;
  const {fields: layoutFields} = layout;
  const layoutGriddedFields = layoutFields.slice(0, 7);

  return (
    <Fragment key={layout.title}>
      {!layout.noMandatoryLegend && (
        <p className={"case-step-mandatory-fields-legend paragraph-small-fs9"}><TranslatedText i18nKey="mandatory.fields.legend"/></p>
      )}
      <h2 className="title">{layout.title}</h2>
      <Row>
        <Col xs={12} md={12} className={"content"}>
          <ul style={{marginBottom: "45px"}}>
            <li>
              <TranslatedText i18nKey="tutelaPerdite.dichiarazioneSostitutiva.content.declaration.part_2.li_1"/>
            </li>
            <li>
              <TranslatedText i18nKey="tutelaPerdite.dichiarazioneSostitutiva.content.declaration.part_2.li_2"/>
            </li>
            <li>
              <TranslatedText i18nKey="tutelaPerdite.dichiarazioneSostitutiva.content.declaration.part_2.li_3"/>
            </li>
          </ul>
          <div style={{display: "flex", flexWrap: "wrap",marginLeft: "-1em"}}>
            {layoutGriddedFields.map((item, index) => {
              const gridProps = item.grid;
              const fieldProps = fields[item.fieldName];

              return (
                <Col {...gridProps} key={index}>
                  <CaseFormField {...fieldProps} />
                </Col>
              );
            })}
          </div>
          {/* <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "flex-start",
              marginBottom: "56px",
              alignItems: "center",
            }}
          >
            <i
              className="gc-icon-functional-attention-2-col"
              aria-hidden="true"
            >
              <span className="path1"/>
              <span className="path2"/>
            </i>
            <span className="contentDescription">
              <TranslatedText i18nKey="tutelaPerdite.dichiarazioneSostitutiva.content.declaration.part_2.content"/>{" "}
            </span>
          </div> */}

          <h2 className="title">
            <TranslatedText i18nKey="tutelaPerdite.dichiarazioneSostitutiva.content.declaration.part_3.title"/>
          </h2>
          <p className="description">
            <TranslatedText i18nKey="tutelaPerdite.dichiarazioneSostitutiva.content.declaration.part_3.content_1"/>
          </p>
          <p className="description">
            <TranslatedText i18nKey="tutelaPerdite.dichiarazioneSostitutiva.content.declaration.part_3.content_2"/>
          </p>
          <ul>
            <li>
              <TranslatedText
                i18nKey="tutelaPerdite.dichiarazioneSostitutiva.content.declaration.part_3.content_2.li_1"/>
            </li>
            <li>
              <TranslatedText
                i18nKey="tutelaPerdite.dichiarazioneSostitutiva.content.declaration.part_3.content_2.li_2"/>
            </li>
          </ul>
        </Col>
      </Row>
    </Fragment>
  );
};
const startEventDataLayer = () => {window.dataLayer.push({"event": "pratica", "tipo": CaseForms.TutelaPerdite ,"step": "avvio"})}
let model = {
  formId: CaseForms.TutelaPerdite,
  formField: {
    // step 1.1
    selezioneContrattoTutela: {
      name: 'selezioneContrattoTutela',
      label: <TranslatedText i18nKey="common.contracts"/>,
      placeholder: <TranslatedText i18nKey="cases.contract-select.select-contract"/>,
      loading: <TranslatedText i18nKey="cases.contract-select.loading"/>,
      noContractFound: <TranslatedText i18nKey="cases.contract-select.no-contract-found"/>,
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required"/>,
      type: 'active-contract-select',
      excludeStatusTypes: ['inactive'],
      startEventDataLayer : startEventDataLayer,
      onSelected: (selected, values, setFieldValue, setFieldTouched) => {
        setFieldValue("comune", selected.city);
        setFieldValue("via", `${selected.street} ${selected.streetNumber}`);
        setFieldTouched("comune", false);
        setFieldTouched("via", false);
      },
    },
    comune: {
      name: 'comune',
      label: <TranslatedText i18nKey="cases.request_info.fields.comune.label"/>,
      placeholder: <TranslatedText i18nKey="common.generic.placeholder"/>,
      requiredErrorMsg: <TranslatedText i18nKey='cases.request_info.errors.required'/>,
      type: 'input',
      disabled: true,
      readOnly: true,
    },
    via: {
      name: 'via',
      label: <TranslatedText i18nKey="cases.request_info.fields.via.label"/>,
      placeholder: <TranslatedText i18nKey="common.generic.placeholder"/>,
      requiredErrorMsg: <TranslatedText i18nKey='cases.request_info.errors.required'/>,
      type: 'input',
      disabled: true,
      readOnly: true,
    },
    // step 1.2
    tipoIntestatario: {
      name: 'tipoIntestatario',
      // label: <TranslatedText i18nKey="cases.tipoIntestatario.label"/>,
      summaryView: false,
      placeholder: <TranslatedText i18nKey="common.generic.placeholder"/>,
      requiredErrorMsg: <TranslatedText i18nKey='cases.request_info.errors.required'/>,
      type: 'switch-radio',
      options: [
        {
          label: <TranslatedText i18nKey="cases.voltura.fields.tipo_intestatario.fisica.label"/>,
          value: PersonType.NATURAL,
          grid: {xs: 12, md: 'auto'}
        },
        {
          label: <TranslatedText i18nKey="cases.voltura.fields.tipo_intestatario.giuridica.label"/>,
          value: PersonType.LEGAL,
          grid: {xs: 12, md: 3}
        }
      ],
      onSelected: (selected, values, profile, setFieldValue) => {
        setFieldValue(signValue.name, sign);
        if (profile.role !== UserRoleEnum.MUNICIPAL_OPERATOR) {
          let piva = "";
          let fiscalCode = "";
          if (profile.fiscalCode !== "") {
            if (isNaN(Number(profile.fiscalCode))) {
              fiscalCode = profile.fiscalCode;
            } else {
              piva = profile.fiscalCode;
            }
          }
          if (selected === PersonType.NATURAL) {
            values[name.name] === "" &&
            setFieldValue(name.name, profile.name || "");
            values[surname.name] === "" &&
            setFieldValue(surname.name, profile.surname || "");
            values[fisicaCodiceFiscale.name] === "" &&
            setFieldValue(fisicaCodiceFiscale.name, fiscalCode || "");
            
          }
          if (selected === PersonType.LEGAL) {
            values[giuridicaRagioneSociale.name] === '' && setFieldValue(giuridicaRagioneSociale.name, profile.businessName || '');
            values[giuridicaCodiceFiscale.name] === '' && setFieldValue(giuridicaCodiceFiscale.name, fiscalCode || '');
            values[giuridicaPartitaIVA.name] === '' && setFieldValue(giuridicaPartitaIVA.name, piva || '');
            values[giuridicaPartitaIVA2.name] === '' && setFieldValue(giuridicaPartitaIVA2.name, piva || '');
            values[giuridicaRappresentanteLegaleName.name] === '' && setFieldValue(giuridicaRappresentanteLegaleName.name, profile.name || '');
            values[giuridicaRappresentanteLegaleSurname.name] === '' && setFieldValue(giuridicaRappresentanteLegaleSurname.name, profile.surname || '');
            values[giuridicaSedeLegaleComune.name] === '' && setFieldValue(giuridicaSedeLegaleComune.name, profile.legalAddress_city || '');
            values[giuridicaProvincia.name] === '' && setFieldValue(giuridicaProvincia.name, profile.legalAddress_province || '');
            values[giuridicaCAP.name] === '' && setFieldValue(giuridicaCAP.name, profile.legalAddress_postalCode || '');
            values[giuridicaSedeLegaleIndirizzo.name] === '' && setFieldValue(giuridicaSedeLegaleIndirizzo.name, `${profile.legalAddress_street} ${profile.legalAddress_streetNumber}`);
          }
          values[bollettaEsistenteCellulare.name] === '' && 
              setFieldValue(
                 bollettaEsistenteCellulare.name, profile.mobilePhoneNumber || '');
            values[bollettaEsistenteEmail.name] === '' && 
              setFieldValue(bollettaEsistenteEmail.name, profile.email || '');
        
        }
      },
    },
    fisicaSesso: {
      name: 'fisicaSesso',
      placeholder: <TranslatedText i18nKey="common.generic.placeholder"/>,
      label: <TranslatedText i18nKey="cases.gender"/>,
      requiredErrorMsg: <TranslatedText i18nKey='cases.request_info.errors.required'/>,
      type: 'radio',
      options: [
        {label: PersonSex.M, value: PersonSex.M, grid: {xs: 12, md: 'auto'}},
        {
          label: PersonSex.F, value: PersonSex.F, grid: {xs: 12, md: 3}
        }],
    },
    name: {
      name: 'name',
      label: <TranslatedText i18nKey="cases.request_info.fields.name.label"/>,
      placeholder: <TranslatedText i18nKey="common.generic.placeholder"/>,
      requiredErrorMsg: <TranslatedText i18nKey='cases.request_info.errors.required'/>,
      type: 'input',
    },
    surname: {
      name: 'surname',
      label: <TranslatedText i18nKey="cases.request_info.fields.surname.label"/>,
      placeholder: <TranslatedText i18nKey="common.generic.placeholder"/>,
      requiredErrorMsg: <TranslatedText i18nKey='cases.request_info.errors.required'/>,
      type: 'input',
    },
    fisicaCodiceFiscale: {
      name: 'fisicaCodiceFiscale',
      label: <TranslatedText i18nKey="cases.request_info.fields.codiceFiscale.label"/>,
      placeholder: <TranslatedText i18nKey="common.generic.placeholder"/>,
      requiredErrorMsg: <TranslatedText i18nKey='cases.request_info.errors.required'/>,
      type: 'input',
      uppercase: true,
    },
    fisicaNatoA: {
      name: 'fisicaNatoA',
      label: <TranslatedText i18nKey="cases.request_info.fields.natoA.label"/>,
      placeholder: <TranslatedText i18nKey="common.generic.placeholder"/>,
      requiredErrorMsg: <TranslatedText i18nKey='cases.request_info.errors.required'/>,
      type: "suggestions",
      message: true,
      getItems: (setData) => {
        return getCities()
          .then((items) => setData(items))
          .catch((error) => {
            console.log("Error fetching comuni serviti: ", error);
            setData([]);
          });
      },
      getSuggestions: (data) => {
        return data;
      },
      getSuggestionValue: (suggestion) => {
        return suggestion.city
      },
      renderSuggestion: (suggestion) => {
        return (
          <div>{suggestion.city}</div>
        );
      },
      filter: async (value, data, setData) => {
        const newData = await getCities(value);
        if (setData)
          setData(newData);
        return newData && newData.filter((item) => {
          return (
            String(item.city)
              .toLowerCase()
              .indexOf(String(value).toLowerCase()) > -1
          );
        });
      },
      onSelected: (value, data, setFieldValue) => {
        if (data && data.length) {
          const [selected] = data.filter(
            (item) =>
              String(item.city).toLowerCase() === String(value).toLowerCase()
          );
          if (selected) {
            setFieldValue(fisicaNatoA.name, selected.city);
            setFieldValue(dicSosNatoA.name, selected.city);
          }
        }
      },
      onBlur: (value, data, setValue) => {
        const [selected] = data.filter(
          (item) =>
            String(item.city).toLowerCase() === String(value).toLowerCase()
        );
        selected ? setValue(selected.city) : setValue("");
      },
    },
    fisicaDataNascita: {
      name: 'fisicaDataNascita',
      label: <TranslatedText i18nKey="cases.richiedi_omaggio.dataNascita.label"/>,
      placeholder: <TranslatedText i18nKey="common.generic.placeholder"/>,
      requiredErrorMsg: <TranslatedText i18nKey="cases.request_info.errors.required"/>,
      type: 'date'
    },
    fisicaIndirizzoResidenza: {
      name: 'fisicaIndirizzoResidenza',
      label: <TranslatedText i18nKey="cases.request_info.fields.indirizzoResidenza.label"/>,
      placeholder: <TranslatedText i18nKey="common.generic.placeholder"/>,
      egonLength: 2,
      egonOrder: 2,
      type: "egon-address",
      suggestionType: 'address',
      onError: (value, setFieldValue) => {
        setFieldValue(fisicaIndirizzoResidenza.name, value);
      },
      onChange: (setFieldValue, value) => {
        setFieldValue(fisicaIndirizzoResidenza.name, value);
        setFieldValue(fisicaComuneResidenza.name, "");
        setFieldValue(fisicaCAP.name, "");
        setFieldValue(fisicaProvincia.name, "");
      },
      onSelect: (components, setFieldValue) => {
        setFieldValue(
          fisicaIndirizzoResidenza.name,
          `${components.via}, ${components.civico || ""}`
        );
        setFieldValue(fisicaComuneResidenza.name, components.comune || "");
        setFieldValue(dicSosComuneResidenza.name, components.comune);
        setFieldValue(dicSosProvincia.name, components.provincia);
        setFieldValue(fisicaProvincia.name, components.provincia || "");
        setFieldValue(fisicaCAP.name, components.cap || "");
      },
      step : "1",
    },
    fisicaComuneResidenza: {
      name: 'fisicaComuneResidenza',
      label: <TranslatedText i18nKey="cases.request_info.fields.comuneResidenza.label"/>,
      placeholder: <TranslatedText i18nKey="common.generic.placeholder"/>,
      requiredErrorMsg: <TranslatedText i18nKey='cases.request_info.errors.required'/>,
      type: 'input'
    },
    fisicaProvincia: {
      name: 'fisicaProvincia',
      label: <TranslatedText i18nKey="cases.request_info.fields.provincia.label"/>,
      placeholder: <TranslatedText i18nKey="common.generic.placeholder"/>,
      requiredErrorMsg: <TranslatedText i18nKey='cases.request_info.errors.required'/>,
      type: 'input',
    },
    fisicaCAP: {
      name: 'fisicaCAP',
      label: <TranslatedText i18nKey="cases.request_info.fields.fisicaCap.label"/>,
      placeholder: <TranslatedText i18nKey="common.generic.placeholder"/>,
      invalidErrorMsg: <TranslatedText i18nKey='cases.request_info.errors.cap.invalid'/>,
      type: 'input'
    },
    giuridicaRagioneSociale: {
      name: 'giuridicaRagioneSociale',
      label: <TranslatedText i18nKey="cases.request_info.fields.ragioneSociale.label"/>,
      placeholder: <TranslatedText i18nKey="common.generic.placeholder"/>,
      requiredErrorMsg: <TranslatedText i18nKey='cases.request_info.errors.required'/>,
      labelIcon:  <i
        className="gc-icon-thick-info"
        aria-hidden="true"
        style={{ fontSize: "20px" }}
      />,
      infoModalMessage: <TranslatedText i18nKey="cases.businessName.popup.message"/>,

      type: 'input',
    },
    giuridicaCodiceFiscale: {
      name: 'giuridicaCodiceFiscale',
      label: <TranslatedText i18nKey="cases.request_info.fields.codiceFiscale.label"/>,
      placeholder: <TranslatedText i18nKey="common.generic.placeholder"/>,
      requiredErrorMsg: <TranslatedText i18nKey='cases.request_info.errors.required'/>,
      type: 'input',
      uppercase: true,
    },
    giuridicaProvincia: {
      name: 'giuridicaProvincia',
      label: <TranslatedText i18nKey="cases.request_info.fields.provincia.label"/>,
      placeholder: <TranslatedText i18nKey="common.generic.placeholder"/>,
      requiredErrorMsg: <TranslatedText i18nKey='cases.request_info.errors.required'/>,
      type: 'input',
    },

    giuridicaPartitaIVA: {
      name: 'giuridicaPartitaIVA',
      label: <TranslatedText i18nKey="cases.request_info.fields.partitaIVA.label"/>,
      placeholder: <TranslatedText i18nKey="common.generic.placeholder"/>,
      requiredErrorMsg: <TranslatedText i18nKey='cases.request_info.errors.required'/>,
      type: 'input',
    },
    giuridicaPartitaIVA2: {
      name: 'giuridicaPartitaIVA2',
      label: <TranslatedText i18nKey="cases.request_info.fields.partitaIVA.label"/>,
      placeholder: <TranslatedText i18nKey="common.generic.placeholder"/>,
      requiredErrorMsg: <TranslatedText i18nKey='cases.request_info.errors.required'/>,
      type: 'input',
    },
    giuridicaPartitaIVAGrupoCheckbox: {
      name: "giuridicaPartitaIVAGrupoCheckbox",
      label: (
        <TranslatedText i18nKey="cases.allaciamento.step1.2.giuridicaPartitaIVAGrupoCheckbox.label" />
      ),
      type: "checkbox",
    },
    giuridicaPartitaIVAGrupo: {
      name: "giuridicaPartitaIVAGrupo",
      label: (
        <TranslatedText i18nKey="cases.allacciamento.step1_2.giuridicaPartitaIVAGrupo.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder"/>
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "input",
    },
    giuridicaRappresentanteLegaleName: {
      name: 'giuridicaRappresentanteLegaleName',
      label: <TranslatedText i18nKey="cases.request_info.fields.rappresentanteLegaleName.label"/>,
      placeholder: <TranslatedText i18nKey="common.generic.placeholder"/>,
      requiredErrorMsg: <TranslatedText i18nKey='cases.request_info.errors.required'/>,
      type: 'input',
    },
    giuridicaRappresentanteLegaleSurname: {
      name: 'giuridicaRappresentanteLegaleSurname',
      label: <TranslatedText i18nKey="cases.request_info.fields.rappresentanteLegaleSurname.label"/>,
      placeholder: <TranslatedText i18nKey="common.generic.placeholder"/>,
      requiredErrorMsg: <TranslatedText i18nKey='cases.request_info.errors.required'/>,
      type: 'input',
    },
    giuridicaSedeLegaleComune: {
      name: 'giuridicaSedeLegaleComune',
      label: <TranslatedText i18nKey="cases.request_info.fields.sedeLegaleComune.label"/>,
      placeholder: <TranslatedText i18nKey="common.generic.placeholder"/>,
      requiredErrorMsg: <TranslatedText i18nKey='cases.request_info.errors.required'/>,
      type: 'input',
    },

    giuridicaSedeLegaleIndirizzo: {
      name: 'giuridicaSedeLegaleIndirizzo',
      label: <TranslatedText i18nKey="cases.request_info.fields.sedeLegaleIndirizzo.label"/>,
      placeholder: <TranslatedText i18nKey="common.generic.placeholder"/>,
      requiredErrorMsg: <TranslatedText i18nKey='cases.request_info.errors.required'/>,
      type: "egon-address",
      suggestionType: 'address',
      onError: (value, setFieldValue) => {
        setFieldValue(giuridicaSedeLegaleIndirizzo.name, value);
      },
      onChange: (setFieldValue, value) => {
        setFieldValue(giuridicaSedeLegaleIndirizzo.name, value);
        setFieldValue(giuridicaSedeLegaleComune.name, "");
        setFieldValue(giuridicaCAP.name, "");
        setFieldValue(giuridicaProvincia.name, "");
      },
      onSelect: (components, setFieldValue) => {
        setFieldValue(
          giuridicaSedeLegaleIndirizzo.name,
          `${components.via}, ${components.civico || ""}`
        );
        setFieldValue(giuridicaSedeLegaleComune.name, components.comune || "");
        setFieldValue(giuridicaCAP.name, components.cap || "");
        setFieldValue(giuridicaProvincia.name, components.provincia || "");
      },
      step : "1",
    },
    giuridicaCAP: {
      name: 'giuridicaCAP',
      label: <TranslatedText i18nKey="cases.request_info.fields.fisicaCap.label"/>,
      placeholder: <TranslatedText i18nKey="common.generic.placeholder"/>,
      invalidErrorMsg: <TranslatedText i18nKey='cases.request_info.errors.cap.invalid'/>,
      type: 'input',
    },
    //step 2.1
    dicSosName: {
      name: 'dicSosName',
      label: <TranslatedText i18nKey="cases.request_info.fields.name.label"/>,
      placeholder: <TranslatedText i18nKey="cases.request_info.fields.name.placeholder"/>,
      requiredErrorMsg: <TranslatedText i18nKey='cases.request_info.errors.required'/>,
      type: 'input',
    },
    dicSosSurname: {
      name: 'dicSosSurname',
      label: <TranslatedText i18nKey="cases.request_info.fields.surname.label"/>,
      placeholder: <TranslatedText i18nKey="cases.request_info.fields.surname.placeholder"/>,
      requiredErrorMsg: <TranslatedText i18nKey='cases.request_info.errors.required'/>,
      type: 'input',
    },
    dicSosNatoA: {
      name: 'dicSosNatoA',
      label: <TranslatedText i18nKey="cases.request_info.fields.natoA.label"/>,
      placeholder: <TranslatedText i18nKey="common.generic.placeholder"/>,
      type: "egon-address",
      egonLength: 2,
      egonOrder: 1,
      suggestionType: "cities",
      onError: (value, setFieldValue) => {
        setFieldValue(dicSosNatoA.name, value);
      },
      onChange: (setFieldValue, value) => {
        setFieldValue(dicSosNatoA.name, value);
      },
      onSelect: (components, setFieldValue) => {
        setFieldValue(dicSosNatoA.name, components.comune);
      },
      step : "2",
    },
    dicSosDataNascita: {
      name: 'dicSosDataNascita',
      label: <TranslatedText i18nKey="cases.request_info.fields.dataNascita.label"/>,
      placeholder: <TranslatedText i18nKey="common.generic.placeholder"/>,
      requiredErrorMsg: <TranslatedText i18nKey="cases.request_info.errors.required"/>,
      type: 'date'
    },
    dicSosComuneResidenza: {
      name: 'dicSosComuneResidenza',
      label: <TranslatedText i18nKey="cases.request_info.fields.comuneResidenza.label"/>,
      placeholder: <TranslatedText i18nKey="common.generic.placeholder"/>,
      requiredErrorMsg: <TranslatedText i18nKey='cases.request_info.errors.required'/>,
      type: "egon-address",
      egonLength: 2,
      egonOrder: 2,
      suggestionType: "cities",
      onError: (value, setFieldValue) => {
        setFieldValue(dicSosComuneResidenza.name, value);
      },
      onChange: (setFieldValue, value) => {
        setFieldValue(dicSosComuneResidenza.name, value);
        setFieldValue(dicSosProvincia.name, "");
      },
      onSelect: (components, setFieldValue) => {
        setFieldValue(dicSosComuneResidenza.name, components.comune);
        setFieldValue(dicSosProvincia.name, components.provincia);
      },
      step : "2",
    },
    dicSosProvincia: {
      name: 'dicSosProvincia',
      label: <TranslatedText i18nKey="cases.request_info.fields.provincia.label"/>,
      placeholder: <TranslatedText i18nKey="common.generic.placeholder"/>,
      requiredErrorMsg: <TranslatedText i18nKey='cases.request_info.errors.required'/>,
      type: 'input',
    },
    qualita: {
      name: 'qualita',
      label: <TranslatedText i18nKey="cases.request_info.fields.qualita.label"/>,
      type: 'radio',
      options: [
        {
          label: <TranslatedText i18nKey="cases.request_info.fields.qualita.contract_holder"/>,
          value: PersonRoleType.CONTRACT_HOLDER,
          grid: {xs: 12, md: '3'}
        },
        {
          label: <TranslatedText i18nKey="cases.request_info.fields.qualita.legal_representative"/>,
          value: PersonRoleType.LEGAL_REPRESENTATIVE,
          grid: {xs: 12, md: '3'}
        },
        {
          label: <TranslatedText i18nKey="cases.request_info.fields.qualita.other"/>,
          value: PersonRoleType.OTHER,
          grid: {xs: 12, md: '3'}
        }],
    },

    //step 2.2
    letturaDelContatore: {
      name: 'letturaDelContatore',
      placeholder: <TranslatedText i18nKey="common.generic.placeholder"/>,
      label: <TranslatedText i18nKey="cases.request_info.fields.lettura.contatore.label"/>,
      requiredErrorMsg: <TranslatedText i18nKey='cases.request_info.errors.required'/>,
      type: 'input'
    },
    dataLettura: {
      name: 'dataLettura',
      label: <TranslatedText i18nKey="cases.request_info.fields.dataLettura.label"/>,
      placeholder: <TranslatedText i18nKey="common.generic.placeholder"/>,
      requiredErrorMsg: <TranslatedText i18nKey="cases.request_info.errors.required"/>,
      type: 'date',
      onDateChanged: (date, values, setFieldValue) => {
        console.log("Date selected: ", date);
      },
    },
    estremiDocumento: {
      name: 'estremiDocumento',
      placeholder: <TranslatedText i18nKey="common.generic.placeholder"/>,
      label: <TranslatedText i18nKey="cases.request_info.fields.estremi.documento.label"/>,
      requiredErrorMsg: <TranslatedText i18nKey='cases.request_info.errors.required'/>,
      type: 'input',
    },
    // step 3
    signValue: {
      name: "signValue",
      label: <TranslatedText i18nKey="cases.request_info.fields.sign.label" />,
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      invalidErrorMsg: <TranslatedText i18nKey="common.select" />,
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    bollettaRecapitoTipo: {
      name: 'bollettaRecapitoTipo',
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required"/>,
      type: 'radio',
      summaryView: false,
      options: [
        {
          label: <TranslatedText i18nKey="cases.allacciamento.step3_1.bollettaRecapitoTipo.label"/>,
          value: TipoBollettaRecapito.PRE_ESISTENTE,
          grid: {xs: 12}
        },
      ],
    },
    bollettaRecapitoNuovoIndirizzo: {
      name: 'bollettaRecapitoTipo',
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required"/>,
      type: 'radio',
      summaryView: false,
      onChange: (selected, values, setFieldValue) => {
        setFieldValue(bollettaEsistenteIndirizzo.name, "");
        setFieldValue(bollettaEsistenteComune.name, "");
        setFieldValue(bollettaEsistenteProvincia.name, "");
        setFieldValue(bollettaEsistenteCap.name, "");
      },
      options: [
        {
          label: <TranslatedText i18nKey="cases.allacciamento.step3_1.bollettaRecapitoNuovoIndirizzo.label"/>,
          value: TipoBollettaRecapito.NUOVO,
          grid: {xs: 12}
        },
      ],
    },
    bollettaPuntoDiFurnitura: {
      name: 'bollettaPuntoDiFurnitura',
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required"/>,
      type: 'button',
      title: <TranslatedText i18nKey="common.select"/>,
      // className: 'selected',
      summaryView: false,
      onClick: (e, values, setFieldValue) => {
        e.target.classList.add('selected');
        document.getElementById(bollettaDatiIntestatario.name).classList.remove("selected");
        const egonOrder = bollettaEsistenteIndirizzo.egonOrder;
        const inputs = document.getElementById(egonOrder ? `egon-widget-${egonOrder}` : "egon-widget").getElementsByClassName("autocomplete-input");
        inputs[0].value = `${values.via}`;
        setFieldValue(bollettaEsistenteIndirizzo.name, `${values.via}`);
        setFieldValue(bollettaEsistenteComune.name, values.comune);
        setFieldValue(bollettaEsistenteProvincia.name, '');
        setFieldValue(bollettaEsistenteCap.name, '');
      }
    },
    bollettaDatiIntestatario: {
      name: 'bollettaDatiIntestatario',
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required"/>,
      type: 'button',
      summaryView: false,
      title: <TranslatedText i18nKey="common.select"/>,
      onClick: (e, values, setFieldValue) => {
        e.target.classList.add('selected');
        document.getElementById(bollettaPuntoDiFurnitura.name).classList.remove("selected");
        const egonOrder = bollettaEsistenteIndirizzo.egonOrder;
        const inputs = document.getElementById(egonOrder ? `egon-widget-${egonOrder}` : "egon-widget").getElementsByClassName("autocomplete-input");
        const value = values.tipoIntestatario === PersonType.NATURAL ? values.fisicaIndirizzoResidenza : values.giuridicaSedeLegaleIndirizzo;
        inputs[0].value = value;
        let egonCodeResponse = PersonType.NATURAL ? {...fisicaIndirizzoResidenza.egonCodeResponse} : {...giuridicaSedeLegaleIndirizzo.egonCodeResponse};
        egonCodeResponse.tipo_Indirizzo ="recapito";
        bollettaEsistenteIndirizzo.egonCodeResponse = egonCodeResponse;
        setFieldValue(bollettaEsistenteIndirizzo.name, value);
        setFieldValue(bollettaEsistenteComune.name, values.tipoIntestatario === PersonType.NATURAL ? values.fisicaComuneResidenza : values.giuridicaSedeLegaleComune);
        setFieldValue(bollettaEsistenteProvincia.name, values.tipoIntestatario === PersonType.NATURAL ? values.fisicaProvincia : values.giuridicaProvincia);
        setFieldValue(bollettaEsistenteCap.name, values.tipoIntestatario === PersonType.NATURAL ? values.fisicaCAP : values.giuridicaCAP);
      }
    },
    bollettaEsistenteIndirizzo: {
      name: 'bollettaEsistenteIndirizzo',
      label: <TranslatedText i18nKey="cases.voltura.fields.nuovo_indirizzo.indirizzo.label"/>,
      placeholder: <TranslatedText i18nKey="cases.request_info.fields.placeholder"/>,
      type: "egon-address",
      suggestionType: 'address',
      onError: (value, setFieldValue) => {
        setFieldValue(bollettaEsistenteIndirizzo.name, value);
      },
      onChange: (setFieldValue, value) => {
        setFieldValue(bollettaEsistenteIndirizzo.name, value);
        setFieldValue(bollettaEsistenteComune.name, "");
        setFieldValue(bollettaEsistenteCap.name, "");
        setFieldValue(bollettaEsistenteProvincia.name, "");
      },
      onSelect: (components, setFieldValue) => {
        const isStreetValid = (typeof components.civico !== 'undefined') && (typeof components.via !== 'undefined');
        setFieldValue(bollettaEsistenteIndirizzo.name, isStreetValid ? `${components.via}, ${components.civico}` : '');
        setFieldValue(bollettaEsistenteComune.name, components.comune || "");
        setFieldValue(bollettaEsistenteCap.name, components.cap || "");
        setFieldValue(bollettaEsistenteProvincia.name, components.provincia || "");
      },
      step : "3",
    },
    bollettaEsistenteComune: {
      name: 'bollettaEsistenteComune',
      label: <TranslatedText i18nKey="cases.request_info.fields.comune.label"/>,
      placeholder: <TranslatedText i18nKey="cases.voltura.fields.comune.placeholder"/>,
      type: "input",
    },
    bollettaEsistenteCap: {
      name: 'bollettaEsistenteCap',
      label: <TranslatedText i18nKey="cases.voltura.fields.cap.label"/>,
      placeholder: <TranslatedText i18nKey="cases.voltura.fields.cap.placeholder"/>,
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required"/>,
      type: 'input'
    },
    bollettaEsistenteProvincia: {
      name: 'bollettaEsistenteProvincia',
      label: <TranslatedText i18nKey="cases.request_info.fields.provincia.label"/>,
      placeholder: <TranslatedText i18nKey="cases.request_info.fields.placeholder"/>,
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required"/>,
      type: 'input',
    },
    bollettaNomePresso: {
      name: "bollettaNomePresso",
      label: <TranslatedText i18nKey="cases.voltura.fields.presso.nome.label" />,
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    bollettaCognomePresso: {
      name: "bollettaCognomePresso",
      label: <TranslatedText i18nKey="cases.voltura.fields.presso.cognome.label" />,
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    bollettaEsistenteCellulare: {
      name: 'bollettaEsistenteCellulare',
      label: <TranslatedText i18nKey="cases.request_info.fields.cellulare.label.required"/>,
      placeholder: <TranslatedText i18nKey="cases.request_info.fields.placeholder"/>,
      invalidErrorMsg: <TranslatedText i18nKey="cases.request_info.errors.cellulare.invalid"/>,
      requiredErrorMsg: <TranslatedText i18nKey="cases.request_info.errors.cellulare.required"/>,
      type: 'input',
    },
    bollettaEsistenteFisso: {
      name: 'bollettaEsistenteFisso',
      label: <TranslatedText i18nKey="cases.voltura.fields.telefono_fisso.label"/>,
      placeholder: <TranslatedText i18nKey="cases.request_info.fields.placeholder"/>,
      invalidErrorMsg: <TranslatedText i18nKey="cases.request_info.errors.telefono.invalid"/>,
      type: 'input',
    },
    bollettaEsistenteEmail: {
      name: 'bollettaEsistenteEmail',
      label: <TranslatedText i18nKey="cases.request_info.fields.email.label.required"/>,
      placeholder: <TranslatedText i18nKey="cases.request_info.fields.placeholder"/>,
      invalidErrorMsg: <TranslatedText i18nKey="cases.request_info.errors.email.invalid"/>,
      requiredErrorMsg: <TranslatedText i18nKey="cases.request_info.errors.email.required"/>,
      type: 'input',
    },
    bollettaEsistenteConfirmEmail: {
      name: "bollettaEsistenteConfirmEmail",
      label: <TranslatedText i18nKey="cases.digitalization.confirm" />,
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      invalidErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.email.invalid" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
      onCopy: true,
      onPaste: true,
    },
    bollettaEsistentePec: {
      name: 'bollettaEsistentePec',
      label: <TranslatedText i18nKey="cases.voltura.fields.indirizzo_pec.label"/>,
      placeholder: <TranslatedText i18nKey="cases.request_info.fields.placeholder"/>,
      invalidErrorMsg: <TranslatedText i18nKey="cases.request_info.errors.pec.invalid"/>,
      type: 'input',
    },
    // New Address
    bollettaNuovoIndirizzo: {
      name: 'bollettaNuovoIndirizzo',
      label: <TranslatedText i18nKey="cases.voltura.fields.nuovo_indirizzo.indirizzo.label"/>,
      placeholder: <TranslatedText i18nKey="cases.request_info.fields.placeholder"/>,
      type: "egon-address",
      suggestionType: 'address',
      onError: (value, setFieldValue) => {
        setFieldValue(bollettaNuovoIndirizzo.name, value);
      },
      onChange: (setFieldValue, value) => {
        setFieldValue(bollettaNuovoIndirizzo.name, value);
        setFieldValue(bollettaNuovoComune.name, "");
        setFieldValue(bollettaNuovoCap.name, "");
        setFieldValue(bollettaNuovoProvincia.name, "");
      },
      onSelect: (components, setFieldValue) => {
        const isStreetValid = (typeof components.civico !== 'undefined') && (typeof components.via !== 'undefined');
        setFieldValue(bollettaNuovoIndirizzo.name, isStreetValid ? `${components.via}, ${components.civico}` : '');
        setFieldValue(bollettaNuovoComune.name, components.comune || "");
        setFieldValue(bollettaNuovoCap.name, components.cap || "");
        setFieldValue(bollettaNuovoProvincia.name, components.provincia || "");
      },
      step : "3",
    },
    bollettaNuovoComune: {
      name: 'bollettaNuovoComune',
      label: <TranslatedText i18nKey="cases.request_info.fields.comune.label"/>,
      placeholder: <TranslatedText i18nKey="cases.voltura.fields.comune.placeholder"/>,
      type: 'input'
    },
    bollettaNuovoCap: {
      name: 'bollettaNuovoCap',
      label: <TranslatedText i18nKey="cases.voltura.fields.cap.label"/>,
      placeholder: <TranslatedText i18nKey="cases.voltura.fields.cap.placeholder"/>,
      type: 'input'
    },
    bollettaNuovoProvincia: {
      name: 'bollettaNuovoProvincia',
      label: <TranslatedText i18nKey="cases.request_info.fields.provincia.label"/>,
      placeholder: <TranslatedText i18nKey="cases.request_info.fields.placeholder"/>,
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required"/>,
      type: 'input',
    },
    bollettaNuovoNomePresso: {
      name: 'bollettaNuovoNomePresso',
      label: <TranslatedText i18nKey="cases.voltura.fields.presso.nome.label" />,
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    bollettaNuovoCognomePresso: {
      name: 'bollettaNuovoCognomePresso',
      label: <TranslatedText i18nKey="cases.voltura.fields.presso.cognome.label" />,
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    bollettaNuovoCellulare: {
      name: 'bollettaNuovoCellulare',
      label: <TranslatedText i18nKey="cases.request_info.fields.cellulare.label.required"/>,
      placeholder: <TranslatedText i18nKey="cases.request_info.fields.placeholder"/>,
      invalidErrorMsg: <TranslatedText i18nKey="cases.request_info.errors.cellulare.invalid"/>,
      requiredErrorMsg: <TranslatedText i18nKey="cases.request_info.errors.cellulare.required"/>,
      type: 'input',
    },
    bollettaNuovoFisso: {
      name: 'bollettaNuovoFisso',
      label: <TranslatedText i18nKey="cases.voltura.fields.telefono_fisso.label"/>,
      placeholder: <TranslatedText i18nKey="cases.request_info.fields.placeholder"/>,
      invalidErrorMsg: <TranslatedText i18nKey="cases.request_info.errors.telefono.invalid"/>,
      type: 'input',
    },
    bollettaNuovoEmail: {
      name: 'bollettaNuovoEmail',
      label: <TranslatedText i18nKey="cases.request_info.fields.email.label.required"/>,
      placeholder: <TranslatedText i18nKey="cases.request_info.fields.placeholder"/>,
      invalidErrorMsg: <TranslatedText i18nKey="cases.request_info.errors.email.invalid"/>,
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required"/>,
      type: 'input',
    },
    bollettaNuovoConfirmEmail: {
      name: 'bollettaNuovoConfirmEmail',
      label: <TranslatedText i18nKey="cases.digitalization.confirm" />,
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      invalidErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.email.invalid" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
      onCopy: true,
      onPaste: true,
    },
    bollettaNuovoPec: {
      name: 'bollettaNuovoPec',
      label: <TranslatedText i18nKey="cases.voltura.fields.indirizzo_pec.label"/>,
      placeholder: <TranslatedText i18nKey="cases.request_info.fields.placeholder"/>,
      invalidErrorMsg: <TranslatedText i18nKey="cases.request_info.errors.email.invalid"/>,
      type: 'input',
    },

    //step 5
    idType: {
      name: "idType",
      label: <TranslatedText i18nKey="cases.digitalization.idType.placeholder" />,
      placeholder: (<TranslatedText i18nKey="cases.richiedi_omaggio.idType.placeholder" />),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "select",
      options: [
        {
          label: "",
          value: "",
        },
        {
          label: <TranslatedText i18nKey="ID" />,
          value: "ID",
        },
        {
          label: <TranslatedText i18nKey="Passport" />,
          value: "Passport",
        },
        {
          label: <TranslatedText i18nKey="Driving_licence" />,
          value: "Driving_licence",
        },
      ],
    },
    ID: {
      name: "ID",
      label: <TranslatedText i18nKey="cases.request_info.fields.ID.label" />,
      invalidErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.file.not_supported" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.file.required" />
      ),
      type: "s3File",
      customPathS3: "upload/", //this set for analisi acqua
      // prefixFileName: 'voltura', //this set for analisi acqua
      prefixFileNameFromInternalFiledName: "idType",
      allowedExtensions: ["application/pdf", "image/jpeg"],
      allowDragAndDrop: false,
      infoUploadModalMessage: (
        <TranslatedText i18nKey="complex.case.file.upload.allowed" />
      ),
    },
  }
};

const {
  formField: {
    selezioneContrattoTutela,
    comune,
    via,
    tipoIntestatario,
    name,
    surname,
    fisicaCodiceFiscale,
    fisicaNatoA,
    fisicaDataNascita,
    fisicaComuneResidenza,
    fisicaProvincia,
    fisicaCAP,
    fisicaSesso,
    fisicaIndirizzoResidenza,
    giuridicaRagioneSociale,
    giuridicaCodiceFiscale,
    giuridicaPartitaIVA,
    giuridicaPartitaIVA2,
    giuridicaPartitaIVAGrupoCheckbox,
    giuridicaPartitaIVAGrupo,
    giuridicaCAP,
    giuridicaProvincia,
    giuridicaRappresentanteLegaleName,
    giuridicaRappresentanteLegaleSurname,
    giuridicaSedeLegaleComune,
    giuridicaSedeLegaleIndirizzo,
    dicSosName,
    dicSosSurname,
    dicSosNatoA,
    dicSosDataNascita,
    dicSosComuneResidenza,
    dicSosProvincia,
    qualita,

    letturaDelContatore,
    dataLettura,
    estremiDocumento,

    signValue,
    bollettaRecapitoTipo,
    bollettaRecapitoNuovoIndirizzo,
    bollettaPuntoDiFurnitura,
    bollettaDatiIntestatario,
    bollettaEsistenteIndirizzo,
    bollettaEsistenteComune,
    bollettaEsistenteCap,
    bollettaEsistenteProvincia,
    bollettaNomePresso,
    bollettaCognomePresso,
    bollettaEsistenteFisso,
    bollettaEsistenteCellulare,
    bollettaEsistenteEmail,
    bollettaEsistentePec,
    bollettaNuovoIndirizzo,
    bollettaNuovoComune,
    bollettaNuovoCap,
    bollettaNuovoProvincia,
    bollettaNuovoNomePresso,
    bollettaNuovoCognomePresso,
    bollettaNuovoFisso,
    bollettaNuovoCellulare,
    bollettaNuovoEmail,
    bollettaNuovoPec,
    bollettaEsistenteConfirmEmail,
    bollettaNuovoConfirmEmail,

    //step 5
    ID,
    idType,
  },
} = model;

// initialValues contiene i valori iniziali del form, ne imposta anche i campi.
// Si può usare per popolare il form eventualmente.
const initialValues = {
  // step 1.1
  [selezioneContrattoTutela.name]: "",
  [comune.name]: "",
  [via.name]: "",

  // step 1.2
  [tipoIntestatario.name]: PersonType.NATURAL,
  [fisicaSesso.name]: PersonSex.M,
  [name.name]: "",
  [surname.name]: "",
  [fisicaCodiceFiscale.name]: "",
  [fisicaNatoA.name]: "",
  [fisicaDataNascita.name]: "",
  [fisicaComuneResidenza.name]: "",
  [fisicaProvincia.name]: "",
  [fisicaCAP.name]: "",
  [fisicaIndirizzoResidenza.name]: "",
  [giuridicaRagioneSociale.name]: "",
  [giuridicaCodiceFiscale.name]: "",
  [giuridicaPartitaIVA.name]: "",
  [giuridicaPartitaIVA2.name]: "",
  [giuridicaPartitaIVAGrupoCheckbox.name]: false,
  [giuridicaPartitaIVAGrupo.name]: "",
  [giuridicaProvincia.name]: "",
  [giuridicaCAP.name]: "",
  [giuridicaRappresentanteLegaleName.name]: "",
  [giuridicaRappresentanteLegaleSurname.name]: "",
  [giuridicaSedeLegaleComune.name]: "",
  [giuridicaSedeLegaleIndirizzo.name]: "",

  //step 2.1
  [dicSosName.name]: "",
  [dicSosSurname.name]: "",
  [dicSosNatoA.name]: "",
  [dicSosDataNascita.name]: "",
  [dicSosComuneResidenza.name]: "",
  [dicSosProvincia.name]: "",
  [qualita.name]: PersonRoleType.CONTRACT_HOLDER,

  //step 2.2
  [letturaDelContatore.name]: "",
  [dataLettura.name]: "",
  [estremiDocumento.name]: "",

  //step 3.1
  [signValue.name]: "",
  // bollettaRecapitoNuovoIndirizzo needs to be before bollettaRecapitoTipo so that the default value can stay
  [bollettaRecapitoNuovoIndirizzo.name]: '',
  [bollettaRecapitoTipo.name]: TipoBollettaRecapito.PRE_ESISTENTE,
  [bollettaPuntoDiFurnitura.name]: '',
  [bollettaDatiIntestatario.name]: '',
  [bollettaEsistenteIndirizzo.name]: '',
  [bollettaEsistenteComune.name]: '',
  [bollettaEsistenteCap.name]: '',
  [bollettaEsistenteProvincia.name]: '',
  [bollettaNomePresso.name]: "",
  [bollettaCognomePresso.name]: "",
  [bollettaEsistenteFisso.name]: '',
  [bollettaEsistenteCellulare.name]: '',
  [bollettaEsistenteEmail.name]: '',
  [bollettaEsistentePec.name]: '',
  [bollettaNuovoIndirizzo.name]: '',
  [bollettaNuovoComune.name]: '',
  [bollettaNuovoCap.name]: '',
  [bollettaNuovoProvincia.name]: '',
  [bollettaNuovoNomePresso.name]: '',
  [bollettaNuovoCognomePresso.name]: '',
  [bollettaNuovoFisso.name]: '',
  [bollettaNuovoCellulare.name]: '',
  [bollettaNuovoEmail.name]: '',
  [bollettaNuovoPec.name]: '',
  [bollettaEsistenteConfirmEmail.name]: "",
  [bollettaNuovoConfirmEmail.name]: "",

  //step 5
  [ID.name]: "",
  [idType.name]: "",   

};

// Per definire il validationSchema si usa un array di shape che indicano gli step.
// L'ordine degli step deve corrispondere a quello in layout.
const getValidationSchema = () => {
  const validationFiscalCode = getValidationRule("fiscalCode");
  const validationNumber = getValidationRule('number');
  const validationEmail = getValidationRule('email');
  const validationPhone = getValidationRule('phone');
  const validationBusinessName = getValidationObject("businessName");


  return [
    Yup.object().shape({
      [selezioneContrattoTutela.name]: Yup.string().required(
        selezioneContrattoTutela.requiredErrorMsg
      ),
      [comune.name]: Yup.string().trim(<TranslatedText
        i18nKey="common.empty_characters"/>).strict(true).required(comune.requiredErrorMsg),
      [via.name]: Yup.string().trim(<TranslatedText
        i18nKey="common.empty_characters"/>).strict(true).required(via.requiredErrorMsg),
    }),
    Yup.object().shape({
      [tipoIntestatario.name]: Yup.string().required(`${tipoIntestatario.requiredErrorMsg}`),
      [name.name]: Yup.string()
        .when(tipoIntestatario.name, {
          is: (field) => field === PersonType.NATURAL,
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters"/>).strict(true)
            .required(<TranslatedText i18nKey="common.generic.required.input"/>),
        }),
      [surname.name]: Yup.string()
        .when(tipoIntestatario.name, {
          is: (field) => field === PersonType.NATURAL,
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters"/>).strict(true)
            .required(<TranslatedText i18nKey="common.generic.required.input"/>),
        }),
      [fisicaCodiceFiscale.name]: Yup.string()
        .when([tipoIntestatario.name], {
          is: (field) => field === PersonType.NATURAL,
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters"/>).strict(true)
            .min(11, <TranslatedText i18nKey="errors.registration.public.fc.short"/>)
            .max(16, <TranslatedText i18nKey="errors.registration.public.fc.long"/>)
            .matches(validationFiscalCode, {message: <TranslatedText i18nKey="errors.registration.public.fc.match"/>})
            .required(<TranslatedText i18nKey="errors.registration.public.fc.required"/>)
        }),
      [fisicaNatoA.name]: Yup.string()
        .when([tipoIntestatario.name], {
          is: (field) => field === PersonType.NATURAL,
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters"/>).strict(true)
            .required(<TranslatedText i18nKey="common.generic.required.input"/>)
        }),
      [fisicaDataNascita.name]: Yup.string().when(tipoIntestatario.name, {
        is: (field) => field === PersonType.NATURAL,
        then: Yup.string().required(fisicaDataNascita.requiredErrorMsg),
      }),

      [fisicaSesso.name]: Yup.string()
        .when(tipoIntestatario.name, {
          is: (field) => field === PersonType.NATURAL,
          then: Yup.string()
            .required(<TranslatedText i18nKey="common.generic.required.input"/>)
        }),
      [fisicaComuneResidenza.name]: Yup.string()
        .when(tipoIntestatario.name, {
          is: (field) => field === PersonType.NATURAL,
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters"/>).strict(true)
            .required(<TranslatedText i18nKey="common.generic.required.input"/>)
        }),

      [fisicaProvincia.name]: Yup.string()
        .when(tipoIntestatario.name, {
          is: (field) => field === PersonType.NATURAL,
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters"/>).strict(true).max(2,<TranslatedText i18nKey="province.length" />)
            .required(<TranslatedText i18nKey="province.required.message"/>)
        }),
      [fisicaCAP.name]: Yup.number()
        .when(tipoIntestatario.name, {
          is: (field) => field === PersonType.NATURAL,
          then: Yup.number()
            .typeError(fisicaCAP.invalidErrorMsg).required(
              <TranslatedText i18nKey="errors.registration.public.fc.required" />
            )
        }),
      // Persona giuridica
      [giuridicaRagioneSociale.name]: Yup.string()
        .when(tipoIntestatario.name, {
          is: (field) => field === PersonType.LEGAL,
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters"/>).strict(true)
            .required(<TranslatedText i18nKey="common.generic.required.input"/>)
            .matches(validationBusinessName.regex
              , {
                message: (
                  <TranslatedText i18nKey={validationBusinessName?.message_key || ""}/>
                ),
              })
        }),
      [giuridicaCodiceFiscale.name]: Yup.string()
        .when([tipoIntestatario.name, giuridicaPartitaIVA.name], {
          is: (field, giuridicaPartitaIVA) => field === PersonType.LEGAL && !(giuridicaPartitaIVA),
          then: Yup.string()
            .min(11, <TranslatedText i18nKey="errors.registration.public.fc.short"/>)
            .max(16, <TranslatedText i18nKey="errors.registration.public.fc.long"/>)
            .matches(validationFiscalCode, {message: <TranslatedText i18nKey="errors.registration.public.fc.match"/>})
            .required(<TranslatedText i18nKey="errors.registration.public.fc.required"/>)
        }),
      [giuridicaPartitaIVA2.name]: Yup.string().when([tipoIntestatario.name, giuridicaPartitaIVAGrupoCheckbox.name], {
        is: (field, giuridicaPartitaIVAGrupoCheckbox) => field === PersonType.LEGAL && giuridicaPartitaIVAGrupoCheckbox ,
        then: Yup.string()
          .trim(<TranslatedText i18nKey="common.empty_characters"/>).strict(true)
          .matches(validationNumber, {
            message: <TranslatedText i18nKey="cases.request_info.fields.partitaIva.invalid"/>
          })
          .min(11, <TranslatedText i18nKey="errors.registration.public.fc.short"/>)
          .max(11, <TranslatedText i18nKey="errors.registration.public.fc.long"/>)
          .required(<TranslatedText i18nKey="common.generic.required.input"/>)
      }),

      [giuridicaProvincia.name]: Yup.string()
        .when(tipoIntestatario.name, {
          is: (field) => field === PersonType.LEGAL,
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters"/>).strict(true).max(2,<TranslatedText i18nKey="province.length" />)
            .required(<TranslatedText i18nKey="common.generic.required.input"/>)
        }),

      [giuridicaRappresentanteLegaleName.name]: Yup.string()
        .when(tipoIntestatario.name, {
          is: (field) => field === PersonType.LEGAL,
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters"/>).strict(true)
            .required(<TranslatedText i18nKey="common.generic.required.input"/>)
        }),
      [giuridicaPartitaIVAGrupo.name]: Yup.string().when([tipoIntestatario.name, giuridicaPartitaIVAGrupoCheckbox.name], {
        is: (field, checkbox) => field === PersonType.LEGAL && checkbox === true,
        then: Yup.string()
          .trim(<TranslatedText i18nKey="common.empty_characters" />)
          .strict(true)
          .min(
            11,
            <TranslatedText i18nKey="errors.registration.public.fc.short" />
          )
          .max(
            11,
            <TranslatedText i18nKey="errors.registration.public.fc.long" />
          )
          .matches(validationNumber, {
            message: (
              <TranslatedText i18nKey="cases.request_info.fields.partitaIva.invalid" />
            ),
          })
          .required(<TranslatedText i18nKey="common.generic.required.input" />),
      }),

      [giuridicaRappresentanteLegaleSurname.name]: Yup.string()
        .when(tipoIntestatario.name, {
          is: (field) => field === PersonType.LEGAL,
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters"/>).strict(true)
            .required(<TranslatedText i18nKey="common.generic.required.input"/>)
        }),
      [giuridicaSedeLegaleComune.name]: Yup.string()
        .when(tipoIntestatario.name, {
          is: (field) => field === PersonType.LEGAL,
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters"/>).strict(true)
            .required(<TranslatedText i18nKey="common.generic.required.input"/>)
        }),
      [giuridicaCAP.name]: Yup.number()
        .when(tipoIntestatario.name, {
          is: (field) => field === PersonType.LEGAL,
          then: Yup.number().typeError(giuridicaCAP.invalidErrorMsg).required(
            <TranslatedText i18nKey="errors.registration.public.fc.required" />
          ),
        }),
    }),
    Yup.object().shape({

      [giuridicaPartitaIVA.name]: Yup.string()
        .when([tipoIntestatario.name, giuridicaCodiceFiscale.name], {
          is: (field,giuridicaCodiceFiscale ) => field === PersonType.LEGAL && !(giuridicaCodiceFiscale),
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters"/>).strict(true)
            .matches(validationNumber, {
              message: <TranslatedText i18nKey="cases.request_info.fields.partitaIva.invalid"/>
            })
            .min(11, <TranslatedText i18nKey="errors.registration.public.fc.short"/>)
            .max(11, <TranslatedText i18nKey="errors.registration.public.fc.long"/>)
            .required(<TranslatedText i18nKey="common.generic.required.input"/>)
        }),
      [qualita.name]: Yup.string()
        .trim(<TranslatedText i18nKey="common.empty_characters"/>).strict(true)
        .required(qualita.requiredErrorMsg),
      [dicSosName.name]: Yup.string()
        .trim(<TranslatedText i18nKey="common.empty_characters"/>).strict(true)
        .required(dicSosName.requiredErrorMsg),
      [dicSosSurname.name]: Yup.string()
        .trim(<TranslatedText i18nKey="common.empty_characters"/>).strict(true)
        .required(dicSosName.requiredErrorMsg),
      [dicSosNatoA.name]: Yup.string()
        .trim(<TranslatedText i18nKey="common.empty_characters"/>).strict(true)
        .required(<TranslatedText i18nKey="common.generic.required.input"/>),
      [dicSosDataNascita.name]: Yup.string().nullable().required(<TranslatedText
        i18nKey="common.generic.required.input"/>),
      [dicSosComuneResidenza.name]: Yup.string()
        .trim(<TranslatedText i18nKey="common.empty_characters"/>).strict(true)
        .required(dicSosComuneResidenza.requiredErrorMsg),
      [dicSosProvincia.name]: Yup.string()
        .trim(<TranslatedText i18nKey="common.empty_characters"/>).strict(true)
        .required(dicSosProvincia.requiredErrorMsg),
    }),
    Yup.object().shape({
      [letturaDelContatore.name]: Yup.number()
        .typeError(<TranslatedText i18nKey="cases.common.error.invalidNumber"/>)
        // .min(1, <TranslatedText i18nKey="cases.request_info.fields.lettura_decorrenza.min"/>)
        .required(letturaDelContatore.requiredErrorMsg),
      [dataLettura.name]: Yup.string().nullable()
        .required(dataLettura.requiredErrorMsg),
     
    }),
    //step 3.1
    Yup.object().shape({
      // Existing Address
      [bollettaEsistenteCellulare.name]: Yup.string()
        .when(bollettaRecapitoTipo.name, {
          is: (field) => field === TipoBollettaRecapito.PRE_ESISTENTE,
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters"/>).strict(true)
            .matches(validationPhone, {message: bollettaEsistenteCellulare.invalidErrorMsg,})
            .required(bollettaEsistenteCellulare.requiredErrorMsg)
        }),
      [bollettaEsistenteEmail.name]: Yup.string()
        .when(bollettaRecapitoTipo.name, {
          is: (field) => field === TipoBollettaRecapito.PRE_ESISTENTE,
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters"/>).strict(true)
            .matches(validationEmail, {message: bollettaEsistenteEmail.invalidErrorMsg})
            .required(bollettaEsistenteEmail.requiredErrorMsg)
        }),
        [bollettaEsistenteConfirmEmail.name]: Yup.string()
        .when(bollettaRecapitoTipo.name, {
          is: (field) => field === TipoBollettaRecapito.PRE_ESISTENTE,
          then: Yup.string()
            .oneOf(
              [Yup.ref("bollettaEsistenteEmail"), null],
              <TranslatedText i18nKey="cases.request_info.email.match" />
            )
            .required(bollettaEsistenteComune.requiredErrorMsg),
        }),
      [bollettaEsistenteComune.name]: Yup.string()
        .when(bollettaRecapitoTipo.name, {
          is: (field) => field === TipoBollettaRecapito.PRE_ESISTENTE,
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters"/>).strict(true)
            .required(<TranslatedText i18nKey="errors.registration.public.fc.required"/>)
        }),
      [bollettaEsistenteProvincia.name]: Yup.string()
        .when(bollettaRecapitoTipo.name, {
          is: (field) => field === TipoBollettaRecapito.PRE_ESISTENTE,
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters"/>).strict(true)
            .required(<TranslatedText i18nKey="errors.registration.public.fc.required"/>)
        }),
      [bollettaEsistenteFisso.name]: Yup.string()
        .when(bollettaRecapitoTipo.name, {
          is: (field) => field === TipoBollettaRecapito.PRE_ESISTENTE,
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters"/>).strict(true)
            .matches(validationPhone, {message: bollettaEsistenteFisso.invalidErrorMsg})
        }),
      [bollettaEsistenteCap.name]:
        Yup.number()
          .when(bollettaRecapitoTipo.name, {
            is: (field) => field === TipoBollettaRecapito.PRE_ESISTENTE,
            then:Yup.number()
              .typeError(fisicaCAP.invalidErrorMsg)
              .required(
                <TranslatedText i18nKey="errors.registration.public.fc.required" />
              )}),
      [bollettaEsistentePec.name]: Yup.string()
        .when(bollettaRecapitoTipo.name, {
          is: (field) => field === TipoBollettaRecapito.PRE_ESISTENTE,
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters"/>).strict(true)
            .matches(validationEmail, {message: bollettaEsistentePec.invalidErrorMsg})
        }),
      //         // New address
        [bollettaNuovoCellulare.name]: Yup.string()
        .when(bollettaRecapitoTipo.name, {
          is: (field) => field === TipoBollettaRecapito.NUOVO,
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters"/>).strict(true)
            .matches(validationPhone, {message: bollettaNuovoCellulare.invalidErrorMsg})
            .required(bollettaNuovoCellulare.requiredErrorMsg)
        }),
      [bollettaNuovoEmail.name]: Yup.string()
        .when(bollettaRecapitoTipo.name, {
          is: (field) => field === TipoBollettaRecapito.NUOVO,
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters"/>).strict(true)
            .matches(validationEmail, {message: bollettaNuovoEmail.invalidErrorMsg})
            .required(<TranslatedText i18nKey="errors.registration.public.fc.required"/>)
        }),
        [bollettaNuovoConfirmEmail.name]: Yup.string()
        .when(bollettaRecapitoTipo.name, {
          is: (field) => field === TipoBollettaRecapito.NUOVO,
          then: Yup.string()
            .oneOf(
              [Yup.ref("bollettaNuovoEmail"), null],
              <TranslatedText i18nKey="cases.request_info.email.match" />
            )
            .required(bollettaEsistenteComune.requiredErrorMsg),
        }),
      [bollettaNuovoComune.name]: Yup.string()
        .when(bollettaRecapitoTipo.name, {
          is: (field) => field === TipoBollettaRecapito.NUOVO,
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters"/>).strict(true)
            .required(<TranslatedText i18nKey="errors.registration.public.fc.required"/>)
        }),
      [bollettaNuovoCap.name]:
        Yup.number()
          .when(bollettaRecapitoTipo.name, {
            is: (field) => field === TipoBollettaRecapito.NUOVO,
            then:Yup.number()
              .typeError(fisicaCAP.invalidErrorMsg)
              .required(
                <TranslatedText i18nKey="errors.registration.public.fc.required" />
              )}),
      [bollettaNuovoProvincia.name]: Yup.string()
        .when(bollettaRecapitoTipo.name, {
          is: (field) => field === TipoBollettaRecapito.NUOVO,
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters"/>).strict(true)
            .required(<TranslatedText i18nKey="errors.registration.public.fc.required"/>)
        }),
      [bollettaNuovoFisso.name]: Yup.string()
        .when(bollettaRecapitoTipo.name, {
          is: (field) => field === TipoBollettaRecapito.NUOVO,
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters"/>).strict(true)
            .matches(validationPhone, {message: bollettaNuovoFisso.invalidErrorMsg})
        }),
      [bollettaNuovoPec.name]: Yup.string()
        .when(bollettaRecapitoTipo.name, {
          is: (field) => field === TipoBollettaRecapito.NUOVO,
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters"/>).strict(true)
            .matches(validationEmail, {message: bollettaNuovoPec.invalidErrorMsg}),
        }),
    }),
    Yup.object().shape({ }), 
    //step 5
    Yup.object().shape({
      [idType.name]: Yup.string()
        .oneOf(
          idType.options.map((option) => option.value),
          <TranslatedText i18nKey="common.errors.notValid" />
        )
        .required(
          <TranslatedText i18nKey="cases.request_info.errors.required" />
        ),
      [ID.name]: Yup.mixed()
        .required(<TranslatedText i18nKey="cases.errors.required"/>)
        .test("fileSize", "Your file", (value) => value && value !== undefined), 
        [estremiDocumento.name]: Yup.string()
        .trim(<TranslatedText i18nKey="common.empty_characters"/>).strict(true)
        .required(estremiDocumento.requiredErrorMsg),     
    }),   
  ];
};

// Il layout contiene informazioni di testo e di distribuzione sulle griglie
const layout = [
  {
    chapter: true,
    chapterName: <TranslatedText i18nKey="tutelaPerdite.step_1.chapter"/>,
    title: <TranslatedText i18nKey="tutelaPerdite.step_1.title"/>,
    fields: [
      {
        fieldName: "selezioneContrattoTutela",
        grid: {
          xs: 12,
          md: 8,
        },
      },
      {
        fieldName: "comune",
        grid: {
          xs: 12,
          md: 6,
        },
      },
      {
        fieldName: "via",
        grid: {
          xs: 12,
          md: 6,
        },
      },
    ],
  },
  {
    chapter: false,
    title: <TranslatedText i18nKey="tutelaPerdite.step_1.2.title"/>,
    fields: [
      {
        fieldName: "tipoIntestatario",
        grid: {
          xs: 12,
        },
      },
      {
        fieldName: "name",
        grid: {
          xs: 12,
          md: 6,
        },
        condition: [
          {
            if: "tipoIntestatario",
            is: PersonType.NATURAL,
          },
        ],
      },
      {
        fieldName: "surname",
        grid: {
          xs: 12,
          md: 6,
        },
        condition: [
          {
            if: "tipoIntestatario",
            is: PersonType.NATURAL,
          },
        ],
      },
      {
        fieldName: "fisicaCodiceFiscale",
        grid: {
          xs: 12,
          md: 6,
        },
        condition: [
          {
            if: "tipoIntestatario",
            is: PersonType.NATURAL,
          },
        ],
      },
      {
        fieldName: "fisicaNatoA",
        grid: {
          xs: 12,
          md: 6,
        },
        condition: [
          {
            if: "tipoIntestatario",
            is: PersonType.NATURAL,
          },
        ],
      },
      {
        fieldName: "fisicaDataNascita",
        grid: {
          xs: 12,
          md: 6,
        },
        condition: [
          {
            if: "tipoIntestatario",
            is: PersonType.NATURAL,
          },
        ],
      },
      {
        fieldName: "fisicaSesso",
        grid: {
          xs: 12,
          md: 6,
        },
        condition: [
          {
            if: "tipoIntestatario",
            is: PersonType.NATURAL,
          },
        ],
      },
      {
        fieldName: "fisicaIndirizzoResidenza",
        grid: {
          xs: 12,
          md: 6,
        },
        condition: [
          {
            if: "tipoIntestatario",
            is: PersonType.NATURAL,
          },
        ],
      },
      {
        fieldName: "fisicaComuneResidenza",
        grid: {
          xs: 12,
          md: 4,
        },
        condition: [
          {
            if: "tipoIntestatario",
            is: PersonType.NATURAL,
          },
        ],
      },
      {
        fieldName: "fisicaProvincia",
        grid: {
          xs: 12,
          md: 4,
        },
        condition: [
          {
            if: "tipoIntestatario",
            is: PersonType.NATURAL,
          },
        ],
      },
      {
        fieldName: "fisicaCAP",
        grid: {
          xs: 12,
          md: 4,
        },
        condition: [
          {
            if: "tipoIntestatario",
            is: PersonType.NATURAL,
          },
        ],
      },
      {
        fieldName: "giuridicaRagioneSociale",
        grid: {
          xs: 12,
          md: 6,
        },
        condition: [
          {
            if: "tipoIntestatario",
            is: PersonType.LEGAL,
          },
        ],
      },
      {
        fieldName: "giuridicaCodiceFiscale",
        grid: {
          xs: 12,
          md: 6,
        },
        condition: [
          {
            if: "tipoIntestatario",
            is: PersonType.LEGAL,
          },
        ],
      },
      {
        fieldName: "giuridicaPartitaIVA",
        grid: {
          xs: 12,
          md: 6,
        },
        condition: [
          {
            if: "tipoIntestatario",
            is: PersonType.LEGAL,
          },
          {
            if: "giuridicaPartitaIVAGrupoCheckbox",
            is: false,
          }
        ],
      },
      {
        fieldName: "giuridicaPartitaIVA2",
        grid: {
          xs: 12,
          md: 6,
        },
        condition: [
          {
            if: "tipoIntestatario",
            is: PersonType.LEGAL,
          },
          {
            if: "giuridicaPartitaIVAGrupoCheckbox",
            is: true,
          }
        ],
      },      {
        fieldName: "giuridicaPartitaIVAGrupoCheckbox",
        grid: {
          xs: 12,
          md: 6,
        },
        condition: [
          {
            if: "tipoIntestatario",
            is: PersonType.LEGAL,
          },
        ],
        className: "align-self-center"
      },
      {
        fieldName: "giuridicaPartitaIVAGrupo",
        grid: {
          xs: 12,
          md: 6,
        },
        condition: [
          {
            if: "tipoIntestatario",
            is: PersonType.LEGAL,
          },
          {
            if: "giuridicaPartitaIVAGrupoCheckbox",
            is: true,
          }
        ],
      },
      {
        fieldName: null,
        grid: {
          xs: 12,
          md: 6,
        },
        condition: [
          {
            if: "tipoIntestatario",
            is: PersonType.LEGAL,
          },
          {
            if: "giuridicaPartitaIVAGrupoCheckbox",
            is: true,
          }
        ],
      },

      {
        fieldName: "giuridicaRappresentanteLegaleName",
        grid: {
          xs: 12,
          md: 6,
        },
        condition: [
          {
            if: "tipoIntestatario",
            is: PersonType.LEGAL,
          },
        ],
      },
      {
        fieldName: "giuridicaRappresentanteLegaleSurname",
        grid: {
          xs: 12,
          md: 6,
        },
        condition: [
          {
            if: "tipoIntestatario",
            is: PersonType.LEGAL,
          },
        ],
      },
      {
        fieldName: "giuridicaSedeLegaleIndirizzo",
        grid: {
          xs: 12,
          md: 6,
        },
        condition: [
          {
            if: "tipoIntestatario",
            is: PersonType.LEGAL,
          },
        ],
      },
      {
        fieldName: "giuridicaSedeLegaleComune",
        grid: {
          xs: 12,
          md: 4,
        },
        condition: [
          {
            if: "tipoIntestatario",
            is: PersonType.LEGAL,
          },
        ],
      },
      {
        fieldName: "giuridicaProvincia",
        grid: {
          xs: 12,
          md: 4,
        },
        condition: [
          {
            if: "tipoIntestatario",
            is: PersonType.LEGAL,
          },
        ],
      },
      {
        fieldName: "giuridicaCAP",
        grid: {
          xs: 12,
          md: 4,
        },
        condition: [
          {
            if: "tipoIntestatario",
            is: PersonType.LEGAL,
          },
        ],
      },
    ],
  },
  {
    chapter: true,
    chapterName: <TranslatedText i18nKey="tutelaPerdite.step_2.1.chapter"/>,
    title: <TranslatedText i18nKey="tutelaPerdite.step_2.1.title"/>,
    fields: [
      {
        fieldName: "dicSosName",
        grid: {
          xs: 12,
          md: 6,
        },
      },
      {
        fieldName: "dicSosSurname",
        grid: {
          xs: 12,
          md: 6,
        },
      },
      {
        fieldName: "dicSosNatoA",
        grid: {
          xs: 12,
          md: 3,
        },
      },
      {
        fieldName: "dicSosDataNascita",
        grid: {
          xs: 12,
          md: 3,
        },
      },
      {
        fieldName: "dicSosComuneResidenza",
        grid: {
          xs: 12,
          md: 6,
        },
      },
      {
        fieldName: "dicSosProvincia",
        grid: {
          xs: 12,
          md: 6,
        },
      },
      {
        fieldName: "qualita",
        grid: {
          xs: 12,
        },
      },
    ],
    content: (
      <div>
        <p className="contentTitle">
          <TranslatedText i18nKey="tutelaPerdite.dichiarazioneSostitutiva.content.declaration.title"/>
        </p>
        <p className="declaration">
          <TranslatedText i18nKey="tutelaPerdite.dichiarazioneSostitutiva.content.declaration.part_1"/>
        </p>
        {<TutelaPerditeTable/>}
        <p className="declaration">
          <TranslatedText i18nKey="tutelaPerdite.dichiarazioneSostitutiva.content.declaration.part_2"/>
        </p>
        <p className="declaration">
          <TranslatedText i18nKey="tutelaPerdite.dichiarazioneSostitutiva.content.declaration.part_3"/>
        </p>
      </div>
    ),
    hooks: {
      pre: (values, setFieldValue) => {
        if (values.tipoIntestatario === PersonType.NATURAL) {
          setFieldValue(dicSosName.name, values.name || "");
          setFieldValue(dicSosSurname.name, values.surname || "");
          setFieldValue(dicSosNatoA.name, values.fisicaNatoA || "");
          setFieldValue(dicSosDataNascita.name, values.fisicaDataNascita || "");
          setFieldValue(
            dicSosComuneResidenza.name,
            values.fisicaComuneResidenza
          );
          setFieldValue(
            dicSosProvincia.name,
            values.dicSosProvincia ? values.dicSosProvincia : values.fisicaProvincia
          );
        }
        if (values.tipoIntestatario === PersonType.LEGAL) {
          setFieldValue(dicSosName.name, "");
          setFieldValue(dicSosSurname.name, "");
          setFieldValue(dicSosNatoA.name, "");
          setFieldValue(dicSosDataNascita.name, "");
          setFieldValue(dicSosComuneResidenza.name, "");
          setFieldValue(dicSosProvincia.name, "");
        }
      },
    },
  },
  {
    chapter: false,
    chapterName: <TranslatedText i18nKey="tutelaPerdite.step_2.2.chapter"/>,
    title: <TranslatedText i18nKey="tutelaPerdite.step_2.2.title"/>,
    fields: [
      {
        fieldName: "letturaDelContatore",
        grid: {
          xs: 12,
          md: 6,
        },
      },
      {
        fieldName: "dataLettura",
        grid: {
          xs: 12,
          md: 6,
        },
      },
    ],
    component: Step2_2,
  },
     // step 3.1
     {
      chapter: true,
      chapterName: <TranslatedText i18nKey="cases.allacciamento.step3_1.chapterName"/>,
      title: (
        <TranslatedText i18nKey="cases.allacciamento.step3_1.title"/>
      ),
      hooks: {
        pre: (values, setFieldValue) => {
          setFieldValue(bollettaPuntoDiFurnitura.name, getStandardAddressFormat("cases.address_suggestion.button_1", values.comune, values.via));
          if (values[tipoIntestatario.name] === PersonType.NATURAL) {
            setFieldValue('bollettaDatiIntestatario', getStandardAddressFormat("cases.address_suggestion.button_2", values[fisicaComuneResidenza.name], values[fisicaProvincia.name], values[fisicaCAP.name], values[fisicaIndirizzoResidenza.name]))
          } else {
            setFieldValue('bollettaDatiIntestatario', getStandardAddressFormat("cases.address_suggestion.button_2", values[giuridicaSedeLegaleComune.name], values[giuridicaProvincia.name], values[giuridicaCAP.name], values[giuridicaSedeLegaleIndirizzo.name]))
          }
        },
      },
      component: DigitalizzazioneDocument,
      fields: [
        {
          fieldName: 'bollettaRecapitoTipo',
          grid: {
            md: 6,
            xs: 12
          },
        },
         // New Address
        {
          fieldName: 'bollettaRecapitoNuovoIndirizzo',
          grid: {
            md: 6,
            xs: 12
          },
        },
        // Existing address
        {
          fieldName: 'bollettaPuntoDiFurnitura',
          grid: {
            xs: 12,
            md: 4,
          },
          condition: [{
            if: 'bollettaRecapitoTipo',
            is: TipoBollettaRecapito.PRE_ESISTENTE
          }]
        },
        {
          fieldName: 'bollettaDatiIntestatario',
          grid: {
            xs: 12,
            md: 4,
          },
          condition: [{
            if: 'bollettaRecapitoTipo',
            is: TipoBollettaRecapito.PRE_ESISTENTE
          }]
        },
        {
          fieldName: 'bollettaEsistenteIndirizzo',
          grid: {
            xs: 12,
            md: 6
          },
          condition: [{
            if: 'bollettaRecapitoTipo',
            is: TipoBollettaRecapito.PRE_ESISTENTE
          }]
        },
        {
          fieldName: 'bollettaEsistenteComune',
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [{
            if: 'bollettaRecapitoTipo',
            is: TipoBollettaRecapito.PRE_ESISTENTE
          }]
        },
        {
          fieldName: 'bollettaEsistenteCap',
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [{
            if: 'bollettaRecapitoTipo',
            is: TipoBollettaRecapito.PRE_ESISTENTE
          }]
        },
        {
          fieldName: 'bollettaEsistenteProvincia',
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [{
            if: 'bollettaRecapitoTipo',
            is: TipoBollettaRecapito.PRE_ESISTENTE
          }]
        },
        {
          fieldName: "bollettaNomePresso",
          grid: {
            xs: 12,
            md:6
          },
          condition: [
            {
              if: "bollettaRecapitoTipo",
              is: TipoBollettaRecapito.PRE_ESISTENTE,
            },
          ],
          className: "padding-50",
        },
        {
          fieldName: "bollettaCognomePresso",
          grid: {
            xs: 12,
            md: 6
          },
          condition: [
            {
              if: "bollettaRecapitoTipo",
              is: TipoBollettaRecapito.PRE_ESISTENTE,
            },
          ],
          className: "padding-50",
        },
        {
          fieldName: 'bollettaEsistenteCellulare',
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [{
            if: 'bollettaRecapitoTipo',
            is: TipoBollettaRecapito.PRE_ESISTENTE
          }]
        },
        {
          fieldName: 'bollettaEsistenteFisso',
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [{
            if: 'bollettaRecapitoTipo',
            is: TipoBollettaRecapito.PRE_ESISTENTE
          }]
        },
        {
          fieldName: 'bollettaEsistenteEmail',
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [{
            if: 'bollettaRecapitoTipo',
            is: TipoBollettaRecapito.PRE_ESISTENTE
          }]
        },

        {
          fieldName: "bollettaEsistenteConfirmEmail",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "bollettaRecapitoTipo",
              is: TipoBollettaRecapito.PRE_ESISTENTE,
            },
            (() => {
              const obj = {
                if: "sign",
              };
              Object.defineProperty(obj, "is", {
                get: function () {
                  return sign;
                },
              });
              return obj;
            })(),
          ],
        },
        {
          fieldName: null,
          text: (
            <InfoLabel
              label={<TranslatedText i18nKey="cases.confirm.email.info" />}
            />
          ),
          grid: {
            xs: 12,
          },
          condition: [
            {
              if: "bollettaRecapitoTipo",
              is: TipoBollettaRecapito.PRE_ESISTENTE,
            },
            (() => {
              const obj = {
                if: "sign",
              };
              Object.defineProperty(obj, "is", {
  
                get: function () {
                  return sign;
                },
              });
              return obj;
            })(),
          ],
        },
        {
          fieldName: 'bollettaEsistentePec',
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [{
            if: 'bollettaRecapitoTipo',
            is: TipoBollettaRecapito.PRE_ESISTENTE
          }]
        },
              {
                fieldName: 'bollettaNuovoIndirizzo',
                grid: {
                  xs: 12,
                  md: 6,
                },
                condition: [{
                  if: 'bollettaRecapitoTipo',
                  is: TipoBollettaRecapito.NUOVO
                }]
              },
              {
                fieldName: 'bollettaNuovoComune',
                grid: {
                  xs: 12,
                  md: 6,
                },
                condition: [{
                  if: 'bollettaRecapitoTipo',
                  is: TipoBollettaRecapito.NUOVO
                }]
              },
              {
                fieldName: 'bollettaNuovoCap',
                grid: {
                  xs: 12,
                  md: 6,
                },
                condition: [{
                  if: 'bollettaRecapitoTipo',
                  is: TipoBollettaRecapito.NUOVO
                }]
              },
              {
                fieldName: 'bollettaNuovoProvincia',
                grid: {
                  xs: 12,
                  md: 6,
                },
                condition: [{
                  if: 'bollettaRecapitoTipo',
                  is: TipoBollettaRecapito.NUOVO
                }]
              },
              {
                fieldName: 'bollettaNuovoNomePresso',
                grid: {
                  xs: 12,
                  md: 6
                },
                condition: [{
                  if: 'bollettaRecapitoTipo',
                  is: TipoBollettaRecapito.NUOVO
                }]
              },
              {
                fieldName: 'bollettaNuovoCognomePresso',
                grid: {
                  xs: 12,
                  md: 6
                },
                condition: [{
                  if: 'bollettaRecapitoTipo',
                  is: TipoBollettaRecapito.NUOVO
                }]
              },
              {
                fieldName: null,
                grid: {
                  xs: 12,
                  md: 6
                }
              },
              {
                fieldName: 'bollettaNuovoCellulare',
                grid: {
                  xs: 12,
                  md: 6,
                },
                condition: [{
                  if: 'bollettaRecapitoTipo',
                  is: TipoBollettaRecapito.NUOVO
                }]
              },
              {
                fieldName: 'bollettaNuovoFisso',
                grid: {
                  xs: 12,
                  md: 6,
                },
                condition: [{
                  if: 'bollettaRecapitoTipo',
                  is: TipoBollettaRecapito.NUOVO
                }]
              },
              {
                fieldName: 'bollettaNuovoEmail',
                grid: {
                  xs: 12,
                  md: 6,
                },
                condition: [{
                  if: 'bollettaRecapitoTipo',
                  is: TipoBollettaRecapito.NUOVO
                }]
              },
              {
                fieldName: "bollettaNuovoConfirmEmail",
                grid: {
                  xs: 12,
                  md: 6,
                },
                condition: [
                  {
                    if: "bollettaRecapitoTipo",
                    is: TipoBollettaRecapito.NUOVO,
                  },
                  (() => {
                    const obj = {
                      if: "sign",
                    };
                    Object.defineProperty(obj, "is", {
                      get: function () {
                        return sign;
                      },
                    });
                    return obj;
                  })(),
                ],
              },
              {
                fieldName: null,
                text: (
                  <InfoLabel
                    label={<TranslatedText i18nKey="cases.confirm.email.info" />}
                  />
                ),
                grid: {
                  xs: 12,
                },
                condition: [
                  {
                    if: "bollettaRecapitoTipo",
                    is: TipoBollettaRecapito.NUOVO,
                  },
                  (() => {
                    const obj = {
                      if: "sign",
                    };
                    Object.defineProperty(obj, "is", {
                      get: function () {
                        return sign;
                      },
                    });
                    return obj;
                  })(),
                ],
              },
              {
                fieldName: 'bollettaNuovoPec',
                grid: {
                  xs: 12,
                  md: 6,
                },
                condition: [{
                  if: 'bollettaRecapitoTipo',
                  is: TipoBollettaRecapito.NUOVO
                }]
              },
      ],
    },
    //step  4
  {
    chapter: true,
    chapterName: <TranslatedText i18nKey="tutelaPerdite.step_3.chapter"/>,
    noMandatoryLegend: true,
    title: <TranslatedText i18nKey="tutelaPerdite.step_3.chapter"/>,
    fields: [],
    content: (
      <div className="policy-information">
        <p>
          <TranslatedText i18nKey="tutelaPerdite.informativaPrivacy.content_1"/>
        </p>
        <p>
          <TranslatedText i18nKey="tutelaPerdite.informativaPrivacy.content_2"/>
        </p>
      </div>
    ),
  },

  // step 5
  {
    chapter: true,
    chapterName: <TranslatedText i18nKey="cases.digitalization.title" />,
    title: <TranslatedText i18nKey="cases.digitalization.title" />,
    component: DigitalizzazioneDocument,
    fields: [       
      {
        fieldName: "idType",
        grid: {
          xs: 12,
          md: 6,
        },
      },
      {
        fieldName: "estremiDocumento",
        grid: {
          xs: 12,
          md: 6,
        },
      },
      {
        fieldName: "ID",
        grid: {
          xs: 12,
          md: 6,
        },
        condition: [
          {
            if: "idType",
            is: "ID"
          },
          {
            if: "idType",
            is: "Passport"
          },
          {
            if: "idType",
            is: "Driving_licence"
          }
        ]
      },

    ],
    content: (
      <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "flex-start",
              marginBottom: "56px",
              alignItems: "center",
            }}
          >
            <i
              className="gc-icon-functional-attention-2-col"
              aria-hidden="true"
            >
              <span className="path1"/>
              <span className="path2"/>
            </i>
            <span className="contentDescription">
              <TranslatedText i18nKey="tutelaPerdite.dichiarazioneSostitutiva.content.declaration.part_2.content"/>{" "}
            </span>
          </div>
    )
  },

];

// Contiene dettagli sul case form
const getFormDetails = (digitalization = null) => {
  const pdfLink = getCorrectLink(casesInfoVoltura);
  return {
    title: <TranslatedText i18nKey="cases.names.LEAK_PROTECTION"/>,
    description: digitalization ? (<TranslatedText i18nKey="cases.request_info.tutela_perdite.helpText" />) : (
      <a
        className="link-a"
        href={pdfLink}
        target={"_blank"}
        rel="noopener noreferrer"
      >
        <span
          className="gc-icon-functional-doc-pdf-2-col"
          style={{ verticalAlign: "bottom" }}
        >
          <span className="path1" />
          <span className="path2" />
        </span>{" "}
        {<TranslatedText i18nKey="cases.voltura.description.info" />}
      </a>
    ),
  
    summary: true,
    incompleteActivation: true,
    stepper: CaseStepperType.Full,
    autoOpenHelpModal: !digitalization,
    blockText: (
      <div className="content">
        <p>
          test
        </p>
      </div>
    ),
    helpText: digitalization ?null:(
      <div className={"content"}>
        <p>
          <TranslatedText i18nKey="cases.request_info.tutela_perdite.helpText" />
        </p>
        <p>
          <TranslatedText i18nKey="cases.tutela_perdite.help_text_3"/>
        </p>
        <ul>
          <li>
            <TranslatedText i18nKey="cases.complex.success.pdf.li1"/>{' '}
            <a className="link" href={`mailto:fondoperdite@gruppocap.it`}>
              fondoperdite@gruppocap.it
            </a>
          </li>
          <li>
            <TranslatedText i18nKey="cases.complex.success.pdf.li2.firt_part"/>{' '}
            <span className="bold"><TranslatedText i18nKey="cases.complex.success.pdf.li2.name"/></span>{' '}
            <TranslatedText i18nKey="cases.complex.success.pdf.li2.last_part"/>
          </li>
          <li>
            <TranslatedText i18nKey="cases.complex.success.pdf.li3.fax"/> {' '}
            <span className="bold">
              <TranslatedText i18nKey="cases.complex.success.pdf.li3.fax_number"/>
            </span>
          </li>
        </ul>
        <p><TranslatedText i18nKey="cases.voltura.help_text_2"/></p>
      </div>
    ),
    successText: (
      <>
        <p>
          <TranslatedText i18nKey="cases.complex.success.pdf"/>
        </p>
        <ul>
          <li>
            <TranslatedText i18nKey="cases.complex.success.pdf.li1"/>{' '}
            <a className="link" href={`mailto:fondoperdite@gruppocap.it`}>
              fondoperdite@gruppocap.it
            </a>
          </li>
          <li>
            <TranslatedText i18nKey="cases.complex.success.pdf.li2.firt_part"/>{' '}
            <span className="bold"><TranslatedText i18nKey="cases.complex.success.pdf.li2.name"/></span>{' '}
            <TranslatedText i18nKey="cases.complex.success.pdf.li2.last_part"/>
          </li>
          <li>
            <TranslatedText i18nKey="cases.complex.success.pdf.li3.fax"/> {' '}
            <span className="bold">
              <TranslatedText i18nKey="cases.complex.success.pdf.li3.fax_number"/>
            </span>
          </li>
        </ul>
        <p><TranslatedText i18nKey="cases.complex.success.pdf_part_1"/></p>
      </>
    ),
  }
};

const punctualizationMapping = (payload) => {
  const NATURAL = payload[tipoIntestatario.name] === PersonType.NATURAL;
  const EXISTING = payload[bollettaRecapitoTipo.name] === TipoBollettaRecapito.PRE_ESISTENTE;
  return {
    toSign: false,
    accountHolder: {
      personType: payload[tipoIntestatario.name],
      name: NATURAL ? payload[name.name] : payload[giuridicaRappresentanteLegaleName.name],
      surname: NATURAL ? payload[surname.name] : payload[giuridicaRappresentanteLegaleSurname.name],
      ...(!NATURAL && {businessName: payload[giuridicaRagioneSociale.name]}),
      fiscalCode: NATURAL ? payload[fisicaCodiceFiscale.name] : payload[giuridicaCodiceFiscale.name],
      ...(!NATURAL && { vatNumber:payload[giuridicaPartitaIVAGrupoCheckbox.name] === false? payload[giuridicaPartitaIVA.name] : payload[giuridicaPartitaIVA2.name] }),
      ...(NATURAL && {birthPlace: payload[fisicaNatoA.name]}),
      ...(NATURAL && {birthDate: moment(payload[fisicaDataNascita.name]).format("DD/MM/yyyy")}),
      ...(NATURAL && {sex: payload[fisicaSesso.name]}),
      address: {
        city: NATURAL ? payload[fisicaComuneResidenza.name] : payload[giuridicaSedeLegaleComune.name],
        postalCode: NATURAL ? payload[fisicaCAP.name] : payload[giuridicaCAP.name],
        province: NATURAL ? payload[fisicaProvincia.name] : payload[giuridicaProvincia.name],
        street: NATURAL ? payload[fisicaIndirizzoResidenza.name].split(',')[0] || "" :
          payload[giuridicaSedeLegaleIndirizzo.name].split(',')[0] || "",
        streetNumber: NATURAL ? payload[fisicaIndirizzoResidenza.name].split(',')[1] || "" :
          payload[giuridicaSedeLegaleIndirizzo.name].split(',')[1] || "",
      },
      vatNumberGroupInfo: {
        enabled: payload[giuridicaPartitaIVAGrupoCheckbox.name],
        value: payload[giuridicaPartitaIVAGrupo.name]
      },
      contactsInfo: {
        addressRecapito: {
          city: EXISTING ? payload[bollettaEsistenteComune.name] : payload[bollettaNuovoComune.name],
          postalCode: EXISTING ? payload[bollettaEsistenteCap.name] : payload[bollettaNuovoCap.name],
          province: EXISTING ? payload[bollettaEsistenteProvincia.name] : payload[bollettaNuovoProvincia.name],
          street: EXISTING ? payload[bollettaEsistenteIndirizzo.name].split(',')[0] || "" : payload[bollettaNuovoIndirizzo.name].split(',')[0] || "",
          streetNumber: EXISTING ? payload[bollettaEsistenteIndirizzo.name].split(',')[1] || "" : payload[bollettaNuovoIndirizzo.name].split(',')[1] || "",
          name:EXISTING? payload[bollettaNomePresso.name]: payload[bollettaNuovoNomePresso.name],
          surname: EXISTING? payload[bollettaCognomePresso.name]: payload[bollettaNuovoCognomePresso.name],
        },
        email: EXISTING ? payload[bollettaEsistenteEmail.name] : payload[bollettaNuovoEmail.name],
        ...(EXISTING ? payload[bollettaEsistenteFisso.name] && {landlinePhoneNumber: (payload[bollettaEsistenteFisso.name])} : payload[bollettaNuovoFisso.name] && {
          landlinePhoneNumber: (payload[bollettaNuovoFisso.name])
        }),
        mobilePhoneNumber: EXISTING ? payload[bollettaEsistenteCellulare.name] : payload[bollettaNuovoCellulare.name],
        pec: EXISTING ? payload[bollettaEsistentePec.name] : payload[bollettaNuovoPec.name],
      },
    },
    agreement: {
      privacy: true,
      profiling: true,
      marketing: true,
    },
    currentContract: {
      contractId: payload[selezioneContrattoTutela.name],
      declaration: {
        undersigned: `${payload[dicSosSurname.name]} ${payload[dicSosName.name]}`,
        birthDate: moment(payload[dicSosDataNascita.name]).format("DD/MM/yyyy"),
        birthPlace: payload[dicSosNatoA.name],
        address: {
          city:
            payload[fisicaComuneResidenza.name] ||
            payload[giuridicaSedeLegaleComune.name],
          province:
            payload[fisicaProvincia.name] || payload[giuridicaProvincia.name],
        },
        personRole: payload[qualita.name],
      },
      reading: {
        date: moment(payload[dataLettura.name]).format("DD/MM/yyyy"),
        value: Number(payload[letturaDelContatore.name]),
      },
      identityCardCode: payload[estremiDocumento.name],
    },
    draft: false,
    type: CaseForms.TutelaPerdite,
  };
};


const translatedMapping = (payload,excludeProperties) => {
  const NATURAL = payload[tipoIntestatario.name] === PersonType.NATURAL;
  const EXISTING = payload[bollettaRecapitoTipo.name] === TipoBollettaRecapito.PRE_ESISTENTE;
  if (excludeProperties) {
    return punctualizationMapping(payload);
  }
  return {
    toSign: true,
    attachments: [
      {
        data: payload[ID.name],
      },
    ],
    accountHolder: {
      personType: payload[tipoIntestatario.name],
      name: NATURAL ? payload[name.name] : payload[giuridicaRappresentanteLegaleName.name],
      surname: NATURAL ? payload[surname.name] : payload[giuridicaRappresentanteLegaleSurname.name],
      ...(!NATURAL && {businessName: payload[giuridicaRagioneSociale.name]}),
      fiscalCode: NATURAL ? payload[fisicaCodiceFiscale.name] : payload[giuridicaCodiceFiscale.name],
      ...(!NATURAL && { vatNumber:payload[giuridicaPartitaIVAGrupoCheckbox.name] === false? payload[giuridicaPartitaIVA.name] : payload[giuridicaPartitaIVA2.name] }),
      ...(NATURAL && {birthPlace: payload[fisicaNatoA.name]}),
      ...(NATURAL && {birthDate: moment(payload[fisicaDataNascita.name]).format("DD/MM/yyyy")}),
      ...(NATURAL && {sex: payload[fisicaSesso.name]}),
      address: {
        city: NATURAL ? payload[fisicaComuneResidenza.name] : payload[giuridicaSedeLegaleComune.name],
        postalCode: NATURAL ? payload[fisicaCAP.name] : payload[giuridicaCAP.name],
        province: NATURAL ? payload[fisicaProvincia.name] : payload[giuridicaProvincia.name],
        street: NATURAL ? payload[fisicaIndirizzoResidenza.name].split(',')[0] || "" :
          payload[giuridicaSedeLegaleIndirizzo.name].split(',')[0] || "",
        streetNumber: NATURAL ? payload[fisicaIndirizzoResidenza.name].split(',')[1] || "" :
          payload[giuridicaSedeLegaleIndirizzo.name].split(',')[1] || "",
      },
      vatNumberGroupInfo: {
        enabled: payload[giuridicaPartitaIVAGrupoCheckbox.name],
        value: payload[giuridicaPartitaIVAGrupo.name]
      },
      contactsInfo: {
        addressRecapito: {
          city: EXISTING ? payload[bollettaEsistenteComune.name] : payload[bollettaNuovoComune.name],
          postalCode: EXISTING ? payload[bollettaEsistenteCap.name] : payload[bollettaNuovoCap.name],
          province: EXISTING ? payload[bollettaEsistenteProvincia.name] : payload[bollettaNuovoProvincia.name],
          street: EXISTING ? payload[bollettaEsistenteIndirizzo.name].split(',')[0] || "" : payload[bollettaNuovoIndirizzo.name].split(',')[0] || "",
          streetNumber: EXISTING ? payload[bollettaEsistenteIndirizzo.name].split(',')[1] || "" : payload[bollettaNuovoIndirizzo.name].split(',')[1] || "",
          name:EXISTING? payload[bollettaNomePresso.name]: payload[bollettaNuovoNomePresso.name],
          surname: EXISTING? payload[bollettaCognomePresso.name]: payload[bollettaNuovoCognomePresso.name],
        },
        email: EXISTING ? payload[bollettaEsistenteEmail.name] : payload[bollettaNuovoEmail.name],
        ...(EXISTING ? payload[bollettaEsistenteFisso.name] && {landlinePhoneNumber: (payload[bollettaEsistenteFisso.name])} : payload[bollettaNuovoFisso.name] && {
          landlinePhoneNumber: (payload[bollettaNuovoFisso.name])
        }),
        mobilePhoneNumber: EXISTING ? payload[bollettaEsistenteCellulare.name] : payload[bollettaNuovoCellulare.name],
        pec: EXISTING ? payload[bollettaEsistentePec.name] : payload[bollettaNuovoPec.name],
      },
    },
    agreement: {
      privacy: true,
      profiling: true,
      marketing: true,
    },
    currentContract: {
      contractId: payload[selezioneContrattoTutela.name],
      declaration: {
        undersigned: `${payload[dicSosSurname.name]} ${payload[dicSosName.name]}`,
        birthDate: moment(payload[dicSosDataNascita.name]).format("DD/MM/yyyy"),
        birthPlace: payload[dicSosNatoA.name],
        address: {
          city:
            payload[fisicaComuneResidenza.name] ||
            payload[giuridicaSedeLegaleComune.name],
          province:
            payload[fisicaProvincia.name] || payload[giuridicaProvincia.name],
        },
        personRole: payload[qualita.name],
      },
      reading: {
        date: moment(payload[dataLettura.name]).format("DD/MM/yyyy"),
        value: Number(payload[letturaDelContatore.name]),
      },
      identityCardCode: payload[estremiDocumento.name],
    },
    draft: false,
    type: CaseForms.TutelaPerdite,
  };
};

const translatedInverseMapping = (payload, values) => {
  const errorsFields = payload.map(({field, message}) => {
    return {field, message};
  });
  const mapping = {
    "req.accountHolder.personType": tipoIntestatario.name,
    "req.accountHolder.name": values[tipoIntestatario.name] === PersonType.NATURAL ?
      name.name : giuridicaRappresentanteLegaleName.name,
    "req.accountHolder.surname": values[tipoIntestatario.name] === PersonType.NATURAL ?
      surname.name : giuridicaRappresentanteLegaleSurname.name,
    "req.accountHolder.businessName": giuridicaRagioneSociale.name,
    "req.accountHolder.fiscalCode": values[tipoIntestatario.name] === PersonType.NATURAL ? fisicaCodiceFiscale.name : giuridicaCodiceFiscale,
    "req.accountHolder.vatNumber": giuridicaPartitaIVA.name,
    "req.accountHolder.birthPlace": fisicaNatoA.name,
    "req.accountHolder.sex": fisicaSesso.name,

    "req.accountHolder.address.city": values[tipoIntestatario.name] === PersonType.NATURAL ? fisicaComuneResidenza.name : giuridicaSedeLegaleComune.name,
    "req.accountHolder.address.postalCode": values[tipoIntestatario.name] === PersonType.NATURAL ? fisicaCAP.name : giuridicaCAP.name,
    "req.accountHolder.address.province": values[tipoIntestatario.name] === PersonType.NATURAL ? fisicaProvincia.name : giuridicaProvincia.name,
    "req.accountHolder.address.street": values[tipoIntestatario.name] === PersonType.NATURAL ? fisicaIndirizzoResidenza.name : giuridicaSedeLegaleIndirizzo.name,
    "req.accountHolder.address.streetNumber": values[tipoIntestatario.name] === PersonType.NATURAL ? fisicaIndirizzoResidenza.name : giuridicaSedeLegaleIndirizzo.name,

    "req.currentContract.contractId": selezioneContrattoTutela.name,

    "req.accountHolder.contactsInfo.addressRecapito.city": values[bollettaRecapitoTipo.name] === TipoBollettaRecapito.PRE_ESISTENTE ? bollettaEsistenteComune.name : bollettaNuovoComune.name,
    "req.accountHolder.contactsInfo.addressRecapito.postalCode": values[bollettaRecapitoTipo.name] === TipoBollettaRecapito.PRE_ESISTENTE ? bollettaEsistenteCap.name : bollettaNuovoCap.name,
    "req.accountHolder.contactsInfo.addressRecapito.province": values[bollettaRecapitoTipo.name] === TipoBollettaRecapito.PRE_ESISTENTE ? bollettaEsistenteProvincia.name : bollettaNuovoProvincia.name,
    "req.accountHolder.contactsInfo.addressRecapito.street": values[bollettaRecapitoTipo.name] === TipoBollettaRecapito.PRE_ESISTENTE ? bollettaEsistenteIndirizzo.name : bollettaNuovoIndirizzo.name,
    "req.accountHolder.contactsInfo.addressRecapito.streetNumber": values[bollettaRecapitoTipo.name] === TipoBollettaRecapito.PRE_ESISTENTE ? bollettaEsistenteIndirizzo.name : bollettaNuovoIndirizzo.name,
    "req.accountHolder.contactsInfo.addressRecapito.name":
    bollettaNomePresso.name,
    "req.accountHolder.contactsInfo.addressRecapito.surname":
    bollettaCognomePresso.name,
    "req.accountHolder.contactsInfo.email": values[bollettaRecapitoTipo.name] === TipoBollettaRecapito.PRE_ESISTENTE ? bollettaEsistenteEmail.name : bollettaNuovoEmail.name,
    "req.accountHolder.contactsInfo.landlinePhoneNumber": values[bollettaRecapitoTipo.name] === TipoBollettaRecapito.PRE_ESISTENTE ? bollettaEsistenteFisso.name : bollettaNuovoFisso.name,
    "req.accountHolder.contactsInfo.mobilePhoneNumber": values[bollettaRecapitoTipo.name] === TipoBollettaRecapito.PRE_ESISTENTE ? bollettaEsistenteCellulare.name : bollettaNuovoCellulare.name,
    "req.accountHolder.contactsInfo.pec": values[bollettaRecapitoTipo.name] === TipoBollettaRecapito.PRE_ESISTENTE ? bollettaEsistentePec.name : bollettaNuovoPec.name,

    "req.currentContract.declaration.undersigned": dicSosName.name,
    "req.currentContract.declaration.birthDate": dicSosDataNascita.name,
    "req.currentContract.declaration.birthPlace": dicSosNatoA.name,
    "req.currentContract.declaration.address.city": fisicaComuneResidenza.name,
    "req.currentContract.declaration.address.province": fisicaProvincia.name,
    "req.currentContract.declaration.personRole": qualita.name,

    "req.currentContract.reading.date": dataLettura.name,
    "req.currentContract.reading.value": letturaDelContatore.name,
    "req.currentContract.identityCardCode": estremiDocumento.name,
  };


  return errorsFields.reduce((acc, item) => {
    acc[mapping[item.field]] = item.message;
    return acc;
  }, {});
};

const mutation = {
  type: CaseMutationType.Complex,
};
const getTrackingEventKo = () => () => {window.dataLayer.push({"event": "pratica", "tipo": CaseForms.TutelaPerdite, "step": "invio_richiesta", "esito": "KO" }) }
const getTrackingEvent = () => () => {window.dataLayer.push({"event": "pratica", "tipo": CaseForms.TutelaPerdite, "step": "invio_richiesta", "esito": "OK" }) }
const main = (excludeSteps, counter, signDigital) => {
  sign = signDigital;
  let validation = getValidationSchema();
  if (excludeSteps && counter < 1) {
    const stepsExcluded = excludeSteps;
    let deletedLayout = removeRequiredStep(stepsExcluded, layout);
    const { formField } = model;
    validation = removeDeletedLayoutFields(
      deletedLayout,
      formField,
      initialValues,
      validation
    );
    model = { ...model, formField };
  }
  return {
    model,
    validationSchema: validation,
    initialValues,
    layout,
    formDetails: getFormDetails(sign),
    trackingEventKo : getTrackingEventKo(),
    trackingEvent : getTrackingEvent(),
    translatedMapping,
    translatedInverseMapping,
    mutation,
  };
};

export default main;
